/// <reference path="../../jquery/jquery.d.ts" />

class RoomList {
    private _hlsResource = null;
    private _hlsSupport = false;
    private _hlsObject = [];
    private _currentPreiviewPerformer = null;
    private topchatvisibleinroomlist=false;

    private _configPerPage = 33;
    private _maxpage = 5;

    private currentPage = 1;
    private renderedRoomNum = 0;
    private renderedBigRoomNum = 0;
    private renderedHappyHour = false;
    public fullRoomList = null;
    private autoPagingScrollTop = null;

    private babesHandler = null;
    private roomlist_auto_refresh_seconds = 60;

    public focusedPage = true;
    public lastRandomFreeRoom=null;
    public is_testing=false;

    private lastactive_timout=null;
    private mainpagetitle="";
    private lastrefreshed_ts=0;

    //roomlist params for bugrooms
    private spacebetweenbigrooms=1;
    private bigroomrowsize=2;
    private bigroomcolsize=2;
    private bigroomstartrow=2;
    private promosize=2;

    public consoleLogging=false;

    constructor() {
        let thisref=this;
        if(window.location.href.indexOf("web.beta.apn2.com")!==-1){this.consoleLogging=true;}

        //Top chat megjelenítése/elrejtése
        if(!this.topchatvisibleinroomlist){
            $( "<style>.chatroomcont:not(.frame_chat-app-fullscreen),#frame_chat-app:not(.frame_chat-app-fullscreen) .sxcc-tip-after-show-wrapper {display: none !important;}" +
                "#frame_chat-app:not(.frame_chat-app-fullscreen){top:-10000px;}</style>" ).appendTo( "head" );
        }else{
            $( "<style>#main .content-loading {display: none !important;}</style>" ).appendTo( "head" );
        }

        this.mainpagetitle=$("title").text();

        thisref.fixpagedownbug();

        $(() => {
            //fix chat at top
            //$(".sxcc-chat-closed .sxcc-chat-inner header").click();
            // @ts-ignore

            babesHandler = this.babesHandler = new BabesHandler();

            Promise.all([
                // @ts-ignore
                System.import("app/sxc-chat-client"),
                this.babesHandler.init()
            ]).then(() => {
                this.joinChat(true);

                this._hlsResource = "Hls" in window && window["Hls"];
                this._hlsSupport = this._hlsResource.isSupported();

                this._loadRoomList();

                setInterval(() => {
                    if(!this.is_testing && this.current_active_perf_id==-1 && !this.focusedPage){this._loadRoomList(false,true);}
                    }, this.roomlist_auto_refresh_seconds*1000);

                this._bindPagingLink();

                $(window).on("blur focusout", () => { this.focusedPage = false; });
                $(window).on("focus focusin scroll mousemove", () => {
                    this.focusedPage = true;
                    clearTimeout(this.lastactive_timout);
                    this.lastactive_timout=setTimeout(() => {this.focusedPage = false;},this.roomlist_auto_refresh_seconds*1000);
                });

                this.setupajaxloader();
                this.setupScroller();
                this.setupSettingsHandler();
                this.setuptopupHandler();
            });
        });
    }

    focuser=-1;focusercount=0;
    fixpagedownbug(){
        let thisref=this;
        //focus bug javítása
        thisref.focuser = setInterval(function () {
            thisref.focusercount++;
            try{$(".sxcc-chat-form-input").blur()}catch (e) {}
            if (thisref.focusercount > 200) {   clearInterval(thisref.focuser);}
        }, 300);

        $("*").click(function () {
            clearInterval(thisref.focuser);
        });
    }

    /**
     * Érkezéskor felső chat ablak incializálása és join
     */
    private mypage_loaded_first=false;
    private default_giftpage_show=false;
    joinChat(first=false){
        let thisref=this;
        //localStorage["setItem"]('sxcChat_uiSize', JSON.stringify('fb'));
        // @ts-ignore
        var chatParams = chatParamsGlobal; chatParams.chatIncludeType = 'babesIFrame';
        chatParams.chatForceWindowHeightFS="400";
        if(window.location.href.indexOf("/mypage/") !==-1){//konkrét szobára érkezés. Szükséges javítás muteolás működési bug hoz
            // @ts-ignore
            if(typeof chatExtra != 'undefined') { chatExtra="force_mute"; }

            if(window.location.href.indexOf("/send_gift")!==-1){thisref.default_giftpage_show=true;}
        }
        // @ts-ignore
        window.chatClient = new ChatClientWrapper(chatParams);
        window['chatClient'].app.view.escIgnoreClose=true;
        if(first){
            if(window.location.href.indexOf("/mypage/")===-1){
                setTimeout(function() { thisref.registerChatEventHooks("roomlistReloaded"); }, 1);
            }else{ //konkrét szobára érkezés
                thisref.registerChatEventHooks("app-visible");
                //setTimeout(function() { window['chatClient'].app.showRoom(null/*, 'param-screenName', 'param-profilePic', {}*/); }, 1);//kell hogy látható legyen
            }
        }

        thisref.registerChatEventHooks("roomHistoryChanged");
        thisref.registerChatEventHooks("app-visible2");
        thisref.registerChatEventHooks("setState");
        if(first){ thisref.handleEsc();}
    }

    /**
     * Chat event hookok regisztrálása
     */
    private observerleftright=null;
    private firstcredit=null;
    public registerChatEventHooks(eventname){
        let thisref=this;

        //azonos streamek mellőzése
        if(eventname=="roomHistoryChanged"){ //mindig lefut
            window['chatClient'].app.event.on(eventname, function() {
                let interval=setInterval(function() { thisref.stopStreamIfRunMain(); thisref.centerTopRoomChat(); $(window).trigger('resize'); }, 650);
                setTimeout(function () { clearInterval(interval);  },8000);

                //media gallery, profile
                if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen") || (!thisref.mypage_loaded_first && window.location.href.indexOf("/mypage/")!==-1)){
                    $(".sxcc-user-data").html("");
                    let currentroomid= null
                    try{currentroomid=window["chatClient"].app.roomHistory[window["chatClient"].app.roomHistory.length-1];}catch (e) {}
                    if(currentroomid!=null){
                        setTimeout(() => { thisref.addUserDataFrame(currentroomid); }, 1);//e.log("roomHistoryChanged "+currentroomid);
                    }else if(window.location.href.indexOf("/mypage/")!==-1){
                        let arr1=window.location.href.split("/mypage/");let arr2=arr1[1].split("/");
                        let perfid=(arr2[0].split("?"))[0];
                        setTimeout(() => { thisref.addUserDataFrame(perfid); }, 1);
                    }
                }

                //ha nincs top chat betöltés után reset, ha roomlsit van
                if(!thisref.topchatvisibleinroomlist && !$("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){window['chatClient'].app.reset();}

                //this.log("roomHistoryChanged"+new Date().getTime());
            });
        }else if(eventname=="app-visible"){//konkrét szobára érkezés esetén
            window['chatClient'].app.event.on(eventname, function(visible) {
                if(/*visible &&*/ !thisref.mypage_loaded_first && window.location.href.indexOf("/mypage/")!==-1){
                    setTimeout(function() {thisref._openPerformerFullscreen(null);thisref.mypage_loaded_first=true;}, 1);
                }
            });
        }else if(eventname=="roomlistReloaded"){
            window['chatClient'].app.event.on(eventname, function() {
                if(!thisref.mypage_loaded_first){//főoldalra érkezés érkezés esetén, de csak egyszer fut le változó segítségével
                    thisref.mypage_loaded_first=true;
                    if(thisref.topchatvisibleinroomlist && !$("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){thisref.joinRandomRoom();}
                    $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").off("click");
                    $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").click(thisref._closeChatFuncRoomlist);
                }
            });
        }else if(eventname=="app-visible2"){
            //globális, szükséges a topup panel és a design megfelelő működéséhez
            window['chatClient'].app.event.on("app-visible", function(visible) {
                $(window).trigger('resize');
                if(visible){ $("#wait_chat").hide();}
                else{ $("#wait_chat").show(); }

                //set up scroller for small stream and click event
                thisref.setupScroller(false);
                $(".sxcc-obj-wrapper").click(function(){
                    if($(this).hasClass("sxccs-float-over-reg") && $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                        $(".sxc-chat").animate({ scrollTop:0}, 1);
                        $([document.documentElement, document.body]).animate({scrollTop: $("#frame_chat-app").offset().top }, 1);
                    }
                });

                //Firstcredit promo jalzése SecurionPay JS objektumnak a megfelelő fizetési ikonra kattintáskor
                thisref.firstcredit = new MutationObserver(function(mutations) {
                    if($(".sxcc-topup-panel").hasClass("sxc-visible")){
                        $(".sxcct-amt-item").click(function(){
                            if($(this).hasClass("sxcct-amt-item-promo-firstcredit")){
                                securionPayHandler.creditcard.firstCreditPromo=true;
                            }else{
                                securionPayHandler.creditcard.firstCreditPromo=false;
                            }
                        });
                    }
                });
                thisref.firstcredit.observe($('.sxcc-topup-panel')[0], {  attributes: true   });
            });
        }else if(eventname=="setState"){
            //globális, szükséges pl. a teaser videók automatikus elindításához
            window['chatClient'].app.event.on(eventname, function(currentState,lastState) {
                console.log("currentState:"+ currentState);
                thisref.observerleftright = null;
                if(currentState== 1 << 6 && $("#frame_chat-app").hasClass("frame_chat-app-fullscreen") && thisref.marker_for_hide_chat_if_needed){//ha offline
                    //chat notifikáció eltűntetése
                    $(".sxcc-toast-wrapper").hide();
                    $(".sxcc-toast-wrapper").removeClass("sxc-visible");
                    setTimeout(function () { $(".sxcc-toast-wrapper").show();   },2000);

                    thisref.mypageHideTopChat(false);
                    if(typeof $("#frame_chat-app .mediagallery").attr("data-teaser") !=="undefined" && typeof $("#frame_chat-app #sxcc-obj-video").attr("src") ==="undefined"){//ha van teaser videója
                        $.ajax({
                            url: 'https://videoman.a.apn2.com/api/videoPlayer/video/'+$("#frame_chat-app .mediagallery").attr("data-teaser")+'?tokenID='+window["chatClient"].app.options.auth.tokenID,
                            dataType: 'json'
                        }).done((videoData) => {
                            if(videoData.status != 402) {
                                $("#video-player-teaser-cont").html("").append('<video id="video-player-teaser" controls="controls" controlsList="nodownload" oncontextmenu="return false;" autoplay="autoplay" playsinline="playsinline" src="'+videoData.url+'"></video>')
                                $(".sxcc-wrapper").addClass("teaseron");
                            }
                            //$("#video-player-teaser-cont").html("").append('<video id="video-player-teaser" controls="controls" autoplay="autoplay" playsinline="playsinline" src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4"></video>')
                        });
                    }
                    $(".frame-content .frame-paging .nav").css("top","50%");//balra jobbra nyilak chathez képes horizontálisan középre
                }else if((currentState== 1 << 2 || currentState== 1 << 1) && $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){//reset Ilde elnyelése
                }
                else{
                    thisref.mypageShowTopChat();
                    $("#video-player-teaser-cont").html("");
                    $(".sxcc-wrapper").removeClass("teaseron");
                    $(window).resize();

                    //balra jobbra nyilak chathez képes horizontálisan középre
                    thisref.observerleftright = new MutationObserver(function(mutations) {
                        if( !$(".sxcc-stream-wrapper").hasClass("hidden") && !$("#sxcc-obj-wrapper").hasClass("sxccs-float-over-reg") && $(".sxcc-stream-cover").height()>50){
                            $(".frame-content .frame-paging .nav").css("top",(($(".sxcc-stream-wrapper").offset().top+$(".sxcc-stream-cover").height()+$(".sxcc-bottom").height())/2)+"px");
                        }
                    });
                    thisref.observerleftright.observe($('.sxcc-wrapper')[0], {  attributes: true   });
                }
            });
        }
    }

    /**
     * Esc gomb lekezelése
     */
    public handleEsc(){
        let thisref=this;
        $(window).on("keydown", e =>{
            if (e.keyCode === 27 && !$(".fancybox-container").is(":visible") && !$(".popup").is(":visible")
                && !$(".sxcc-tip-after-show-wrapper").is(":visible") && !$(".sxcc-topup-panel").is(":visible")
                && !$("#perfsearch").is(":visible") && !$(".sxcc-auth-panel-wrapper").is(":visible")){
                    if($(".chatroomcont").is(":visible")){
                        thisref._closeChatFuncRoomlist();
                    }else if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                        thisref._closeChatFuncOpenedRoom(null,true,true);
                    }
            }
            if (e.keyCode === 27 && $("#perfsearch").is(":visible")){
                setTimeout(function() {$("#perfsearch").hide();  }, 1);
            }
        });
    }

    /**
     * Rendom szobára join
     */
    public joinRandomRoom(){
        let thisref=this;

        $.ajax({
            url      : '/ajax/api/roomList/babes-get-random',
            type     : 'GET',
            dataType : 'json',
            data     : {}
        }).done((responseJSON) => {
            if(responseJSON.length>1  && (typeof window['chatClient'].app.chatServer.currentRoom !=="undefined" && window['chatClient'].app.chatServer.currentRoom != null &&  responseJSON.indexOf(window['chatClient'].app.chatServer.currentRoom.roomID)!==-1  )){
                let index = responseJSON.indexOf(window['chatClient'].app.chatServer.currentRoom.roomID);
                responseJSON.splice(index, 1);
            }
            thisref.lastRandomFreeRoom={"roomid":responseJSON[0]};
            window['chatClient'].app.reset(() => {
                window['chatClient'].app.view.setSize("normal");
                window['chatClient'].app.showRoom(thisref.lastRandomFreeRoom==null?51162:thisref.lastRandomFreeRoom.roomid/*,  'param-screenName', 'param-profilePic', {}*/);
                if(thisref.lastRandomFreeRoom!=null){
                    thisref.log("tryleave0 joinRandomRoom:"+thisref.lastRandomFreeRoom.roomid);
                    thisref._bindStreamPreviewLeave(thisref.lastRandomFreeRoom.roomid);
                }
            });
        });


    }

    /**
     * fix center jobb szélső szobalsita eltüntetése miatt
     */
    private lastsum=0;
    public centerTopRoomChat(){
        if(window['chatClient'].app.view.size!="normal"){return;}

        let thisref=this;
        if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
            setTimeout(function () {
                $("#frame_chat-app .sxc-chat:not(.sxcc-size-fs) .sxcc-wrapper").css("max-width","");
                thisref.lastsum=0;
            },100);
        }else{
            setTimeout(function () {
                let sum=$(".sxcc-wrapper .sxcc-chat").width()+$(".sxcc-wrapper .sxcc-stream-wrapper").width();
                if(Math.abs(thisref.lastsum-sum)>15){
                    thisref.lastsum=sum;
                    $("#frame_chat-app:not(.frame_chat-app-fullscreen) .sxc-chat:not(.sxcc-size-fs) .sxcc-wrapper").css("max-width",(sum)+"px");
                }
            },100);
        }
    }

    /**
     * Stream leállítása, ha a fő caht ablakba is fut
     */
    stopStreamIfRunMain(){
        let currentroomid= window["chatClient"].app.roomHistory[window["chatClient"].app.roomHistory.length-1];
        if(window["chatClient"].app.roomHistory.length>0 && $("#video_"+currentroomid).hasClass("auto-preview") && this.current_active_perf_id!=currentroomid){
            this.log("tryleave0 stopStreamIfRunMain:"+currentroomid);
            this._bindStreamPreviewLeave( currentroomid,true);
            if(typeof this.lastRandomFreeRoom!=="undefined" && this.lastRandomFreeRoom!=null && currentroomid!=this.lastRandomFreeRoom.roomid){
                this.log("tryleave0 stopStreamIfRunMain/2:"+this.lastRandomFreeRoom.roomid);
                this._bindStreamPreviewLeave(this.lastRandomFreeRoom.roomid,true);
            }
        }
    }

    /**
     *  Scroll events
     */
    mianscrollerts=0;
    setupScroller(main=true){
        let thisref=this;
        if(main){
            $(window).scroll(() => {
                //Infinite Scroll beállítása
                if($(window).scrollTop() + $(window).height()  >=  $('footer').offset().top ) {
                    $('.roomlist-paging').trigger('click');
                }

                //kicsinyítés törlése, ha register popup után beragadt
                if($(window).scrollTop()  <  $('.sxcc-stream').height() )
                {
                    $(".sxcc-obj-wrapper").removeClass("sxccs-float-over-reg");
                }
            });
        }else{
            $(".sxc-chat").scroll(() => {//mini népzet
                //Mypage-ben kicsinyített kép megjelenítése
                if($(".sxc-chat").hasClass("sxcc-size-normal") &&  $("#frame_chat-app").hasClass("frame_chat-app-fullscreen") && !$(".sxcc-stream-wrapper").hasClass("hidden")
                        && ($(".sxc-chat").scrollTop()  >=  $('.sxcc-stream').height()) && window['chatClient'].app.currentState ==( 1 << 7)){
                    $(".sxcc-obj-wrapper").addClass("sxccs-float-over-reg");
                }else if($(".sxc-chat").hasClass("sxcc-size-normal") &&  $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                    $(".sxcc-obj-wrapper").removeClass("sxccs-float-over-reg");
                }
            });
            $(window).scroll(() => {//fb nézet
                //Mypage-ben kicsinyített kép megjelenítése
                if($(".sxc-chat").hasClass("sxcc-size-fb") &&  $("#frame_chat-app").hasClass("frame_chat-app-fullscreen") && !$(".sxcc-stream-wrapper").hasClass("hidden")
                    && ($(window).scrollTop()  >=  $('.sxcc-stream').height()) && window['chatClient'].app.currentState ==( 1 << 7)){
                    $(".sxcc-obj-wrapper").addClass("sxccs-float-over-reg");
                }else if($(".sxc-chat").hasClass("sxcc-size-fb") &&  $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                    $(".sxcc-obj-wrapper").removeClass("sxccs-float-over-reg");
                }
            });
        }
    }

    /**************************************************************************/

    /**
     * Settings ablak mentések utáni múveletek
     */
    setupSettingsHandler(){
        let thisref=this;
        $(document).ajaxComplete(function(event,request,settings){
            //roomlista frissítése filterek mentésekor
            if ( (settings.url.indexOf("ajax/myaccount/livefilter")!==-1 ||  settings.url.indexOf("ajax/myaccount/roomlist")!==-1 ) && settings.type=="POST" && !thisref.roomlistisloading) {
                thisref._loadRoomList(true,false,true);
            }

            //fix chat at top
            $(".sxcc-chat-closed .sxcc-chat-inner header").click();

            //keresési találatok klikk bind
            $("#perfsearch .results a").click(function (event) {
                event.preventDefault();
                event.stopImmediatePropagation(); //ez állítja meg a többi bind futást
                $("#perfsearch").hide();
                let arr1=$(this).attr("href").split("/mypage/");let arr2=arr1[1].split("/");
                thisref._openPerformerFullscreen({"perfid":arr2[0],"screenname":"","roomimgid":""});
            });
        });
    }

    /**************************************************************************/

    /**
     * Kreditfeltöltéssel kapcsolatos múveletek
     */
    setuptopupHandler(){
        $(window).load(() => {
            $("#topupmenu").click(() => {
                this.babesHandler._checkHappyHourPromo(true);//fontos a sorrend utána a show()
            });
        });
    }

    /**************************************************************************/

    /**
     * Ajax loader hozzáadása
     */
    setupajaxloader(){
        $(document).ajaxSend(function(event, jqxhr, settings){
            if( $("#wait").length==0){
                $('<div id="wait" style="display:none;position:absolute;z-index:99999;margin: auto; top: 0;left: 0; right: 0; bottom: 0;height:80px;width:80px;" ><div class="lds-ellipsis"></div></div>').appendTo($('body' ));
            }
            if(settings.url.indexOf("ajax=1")!==-1){
                if( $('#wait').parent()!=$("body")){
                    $('#wait').css("position","fixed");
                    $('#wait').appendTo($('body'));
                }
                $("#wait").show();
                $('#wait').css("display","block");
            }
        });
        $(document).ajaxComplete(function(event, jqxhr, settings){
            if(settings.url.indexOf("ajax=1")!==-1){
                $("#wait").hide();
            }
        });
    }

    /**************************************************************************/

    /**
     * Szoba lista betöltése
     */
    public roomlistisloading=false;
    private nicereloading_in_progress=false;
    public _loadRoomList(forced=false,nicereload=false,forcedrender=false) {
            if($('#roomlist').find('li').length > 0 && this.focusedPage === true && !forced) { return; }
            if(!$("section.onlineroom-section").is(":visible") || this.nicereloading_in_progress || this.roomlistisloading || $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){return;}
            this.roomlistisloading=true;
            if(nicereload){this.nicereloading_in_progress=true;$(".roomlist-paging").hide();}

            this.renderedRoomNum = 0;
            this.renderedBigRoomNum = 0;

            this._getRoomList().then(() => {
                this.lastrefreshed_ts=new Date().getTime();

                /*if($('#roomlist').find('li').length > 0) {
                    $('#roomlist').css('min-height', $('#roomlist').height());
                }*/

                $('#roomlist'+(nicereload?"_preload":"")+' li').remove();
                this._renderHappyHourPromo()
                    .then(() => {
                        this._renderRoomList(nicereload,forcedrender);
                        this.roomlistisloading=false;
                        this._startRoomPictureTimer();
                        if(nicereload){ this._replaceRoomsNice(); }
                    });
            });
    }
    /**************************************************************************/

    /**
     * Szobalista frissítése animációkkal
     */
    private timeout_addlast=-1;
    _replaceRoomsNice() {
        let thisref=this;
        let preitems=$("#roomlist_preload li.room-item:not(.hidden)");
        if(preitems.length<=6){return;}
        let olditems=$("#roomlist li.room-item:not(.hidden)");

        let i=0; preitems.each(function () {   $(this).attr("data-nth",i+"");i++; });
        i=0; olditems.each(function () {   $(this).attr("data-nth",i+"");i++; });
        for(i=0;i<olditems.length;i++){
            //preitems.eq(i).fadeOut();
            if (olditems.eq(i).hasClass("bigroom")) {
                preitems.eq(i).addClass("bigroom").addClass("brready")
                    .attr("style", olditems.eq(i).attr("style"))
                    .attr("data-col", olditems.eq(i).attr("data-col"))
                    .attr("data-row", olditems.eq(i).attr("data-row"));
            }
        }
        this.replaceFirstXBigroomToPremium(2,"#roomlist_preload");
        let iii=0;

        let idozitoarr=[];
        for(iii=0;iii<olditems.length;iii++) {idozitoarr.push(iii);}
        idozitoarr=idozitoarr.reverse();
        //idozitoarr=this.shuffle(idozitoarr);
        for(iii=0;iii<olditems.length;iii++) {
            setTimeout(function(iii){
                thisref.log("tryleave0 _replaceRoomsNice:"+ $("#roomlist li.room-item[data-nth='" + iii + "']").data('perfid'));
                thisref._bindStreamPreviewLeave( $("#roomlist li.room-item[data-nth='" + iii + "']").data('perfid'),true);
                $("#roomlist li.room-item[data-nth='" + iii + "'] .room-inner").css("z-index","4");
                $("#roomlist_preload li.room-item[data-nth='" + iii + "'] .room-inner").clone().appendTo("#roomlist li.room-item[data-nth='" + iii + "'] .room");
                $("#roomlist li.room-item[data-nth='" + iii + "'] .room-inner:first").animate({ opacity: 0 }, 800,function () {
                    let ii=$(this).closest("li.room-item").attr("data-nth");
                    //$("#roomlist_preload li.room-item[data-nth='" + ii + "']").css("opacity","0.5");
                    if($("#roomlist li.room-item[data-nth='" + ii + "']").length>0){
                        $("#roomlist li.room-item[data-nth='" + ii + "']").replaceWith($("#roomlist_preload li.room-item[data-nth='" + ii + "']"));
                        //$("#roomlist li.room-item[data-nth='" + ii + "']").animate({ opacity: 1 }, 800);
                        thisref._StartStreamsRandom();
                        try{clearTimeout(thisref.timeout_addlast);}catch (e) {}
                        thisref.timeout_addlast=setTimeout(function () { thisref.nicereloading_in_progress=false;thisref._addlastrooms_if_required();},800);
                    }
               });
            },4000+(idozitoarr.pop())*100,iii);
        }
        //Ha több jön, mint előzőleg volt
        /*if(  preitems.length>olditems.length){
            for(iii=olditems.length;iii< preitems.length;iii++) {
                setTimeout(function(iii){
                    $("#roomlist_preload li.room-item[data-nth='" + iii + "']").css("opacity","0");
                    $("#roomlist_preload li.room-item[data-nth='" + iii + "']").insertAfter($("#roomlist li.room-item:last"));
                    $("#roomlist li.room-item[data-nth='" + iii + "']").show();
                    $("#roomlist li.room-item[data-nth='" + iii + "']").animate({ opacity: 1 }, 2000);
                    thisref._StartStreamsRandom();
                },2000+olditems.length+iii*100,iii);
            }
        }*/
        //ha kevesebb jön, mint ami volt
        if(  preitems.length<olditems.length && preitems.length>10){
            for(iii=preitems.length;iii< olditems.length;iii++) {
                setTimeout(function(iii){
                    $("#roomlist li.room-item:last").animate({ opacity: 0 }, 2000,function () {
                        $(this).remove();
                        try{clearTimeout(thisref.timeout_addlast);}catch (e) {}
                        thisref.timeout_addlast=setTimeout(function () {thisref.nicereloading_in_progress=false; thisref._addlastrooms_if_required();},800);
                    });
                },2000+preitems.length+iii*100,iii);
                if(iii>=10){break;}
            }
        }
    }

    /**************************************************************************/

    /**
     * Szobalista utolsó elemeinek kipótlása, ha vannak "hézagok" a végén
     */
    private addinglastrooms=false;
    public _addlastrooms_if_required(instant=false,mainelement="#roomlist",childelement=".room-item",bigroomclass="bigroom",viproomsel=".room-mode-vip",sordbMainElement="") {
        let sordb=this._getColcountPerRow((sordbMainElement==""?mainelement:sordbMainElement)+' '+childelement+'');
        if(sordb==1 || (this.currentPage!=this._maxpage+1 && mainelement=="#roomlist") || (this.nicereloading_in_progress && mainelement=="#roomlist") || this.addinglastrooms || ((!$("section.onlineroom-section").is(":visible") || $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")) && mainelement=="#roomlist")
            || (this.nicereloading_in_progress && instant && mainelement=="#roomlist") || (mainelement!="#roomlist" && $("section.onlineroom-section").is(":visible")) ){return;}
        this.log("_addlastrooms_if_required "+instant+" "+mainelement);
        this.addinglastrooms=true;
        let thisref=this;

        //először duplikátumok eltávolítása ha van valamely oknál fogva
        if(mainelement=="#roomlist"){
            $(mainelement+" li.duplicate").each(function () {
                thisref.log("tryleave0 _addlastrooms_if_required:"+($(this).data('perfid')));
                thisref._bindStreamPreviewLeave($(this).data('perfid'),true);
                $(this).remove();
            });
        }
        if(instant && mainelement=="#roomlist"){this._remove_duplicate_rooms();}

        let roomslen=$(mainelement+" li"+childelement+":not(."+bigroomclass+",.hidden)").length;
        let bigroomslen=($(mainelement+" li"+childelement+"."+bigroomclass+":not(.hidden)").length*(this.bigroomrowsize*this.bigroomcolsize));
        let poromoslen=($(mainelement+" li.promo").length*this.promosize);
        let diff=(roomslen+bigroomslen+poromoslen)%sordb;
        this.log("Addlastrooms: Rooms: "+roomslen+" Bigrooms: "+bigroomslen+" Promos: "+poromoslen+" All: "+(roomslen+bigroomslen+poromoslen)+" Diff: "+sordb);

        //last bigroom fix
        let rows=(roomslen+bigroomslen+poromoslen)/sordb;
        let bigrooms=$(mainelement+" li."+bigroomclass+":not(.hidden)");
        let needtoaddspecial=0;
        if(bigrooms.length>0 && parseInt(bigrooms.last().css("grid-row-start"))>=rows && this.bigroomcolsize<sordb){
            needtoaddspecial=(this.bigroomcolsize*sordb)-(this.bigroomrowsize*this.bigroomcolsize);
            bigrooms.last().attr("data-fixed-bigroom","true");
        }

        //add more if needed
        if(diff!==0 || needtoaddspecial!=0){
            let needtoadd=sordb-diff;
            if(needtoaddspecial!=0){needtoadd=needtoaddspecial;}
            for(let iii=0;iii< needtoadd;iii++) {
                let elem=$(mainelement+" li"+childelement+""+viproomsel+":not(."+bigroomclass+",.hidden)").eq(iii).clone();
                let classes=elem.attr("class").split(" ");
                let theclassarr = jQuery.grep(classes, function(value, i) {return value.indexOf("room-item-") != -1});
                let theclass=theclassarr[0];

                elem.css("opacity","0");
                elem.insertAfter($(mainelement+" li"+childelement+":last"));
                elem.find("a[href*='/mypage/']").click(function () {
                    $(mainelement+" li."+theclass+":not(.duplicate)").first().find("a[href*='/mypage/']").click();
                });
                elem.find(".event-overlay").click(function (event) {
                        event.preventDefault();
                        event.stopImmediatePropagation(); //ez állítja meg a többi bind futást
                        $(mainelement+" li[data-id='"+$(this).closest(".mg-item").attr("data-id")+"']").first().find(".event-overlay").click();
                });
                elem.find("a.favorite").click(function () {
                    $(mainelement+" li."+theclass+":not(.duplicate)").first().find("a.favorite").click();
                });
                elem.find("a.sound").click(function () {
                    try{$(mainelement+" li."+theclass+":not(.duplicate)").first().find("a.sound").click();}catch (e) { }
                    $(this).attr("class",$(mainelement+" li."+theclass+":not(.duplicate)").first().find("a.sound").attr("class"));
                });
                elem.addClass("duplicate");
                if(instant){elem.css("opacity","1");}
                else{elem.animate({ opacity: 1 }, 1800);}
            }
        }
        if(instant){this.addinglastrooms=false;}
        else{
            setTimeout(function () { thisref.addinglastrooms=false;},1800);
        }

        //ha valamely feketelistás valamiért bigroom
        if(mainelement=="#roomlist"){
            this.replaceBlacklistBigroomToNotBlackilst();
        }

        /*if(thisref.currentPage>thisref._maxpage){
            $(".roomlist-paging").show();
        }*/
    }

    /**
     * Feketelistás Bigroom cseréje
     */
    replaceBlacklistBigroomToNotBlackilst(selectorroomlist="#roomlist") {
        let oldelements=$(selectorroomlist+" .room-item.bigroom[data-achivements*='blacklist']");
        oldelements.each(function() {
            let old = $(this);
            let colorig = old.attr("data-col");
            let roworig = old.attr("data-row");
            let news = $(selectorroomlist + " .room-item:not(.bigroom)").not("[data-achivements*='premium']").not("[data-achivements*='blacklist']");
            if (news.length > 0) {
                let new1 = news.first();
                //replace
                new1.css("grid-column-start", colorig);
                new1.attr("data-col", colorig);
                new1.css("grid-row-start", roworig);
                new1.attr("data-row", roworig);
                new1.addClass("bigroom");
                new1.find("img:first").attr('src', new1.new("img:first").attr("data-big-img"));
                old.removeAttr("style");
                old.removeAttr("data-col");
                old.removeAttr("data-row");
                old.removeClass("bigroom");
            }
        });
    }


    /**************************************************************************/

    /**
     * Szobalista duplikátumok eltávolítása
     */
    _remove_duplicate_rooms() {
        let thisref=this;

        $("#roomlist li.room-item:not(.hidden)").each(function () {
            let classes=$(this).attr("class").split(" ");
            let theclassarr = jQuery.grep(classes, function(value, i) {return value.indexOf("room-item-") != -1});
            let theclass=theclassarr[0];
            if($("#roomlist ."+theclass+":not(.duplicate)").length>1){
                thisref.log("tryleave0 _remove_duplicate_rooms:"+$("#roomlist ."+theclass+":last").data('perfid'));
                thisref._bindStreamPreviewLeave($("#roomlist ."+theclass+":last").data('perfid'),true);
                $("#roomlist ."+theclass+":not(.duplicate)").last().remove();
            }
        });

        $("#roomlist_preload li.room-item:not(.hidden)").each(function () {
            let classes=$(this).attr("class").split(" ");
            let theclassarr = jQuery.grep(classes, function(value, i) {return value.indexOf("room-item-") != -1});
            let theclass=theclassarr[0];
            if($("#roomlist_preload ."+theclass+":not(.duplicate)").length>1 ){
                thisref.log("tryleave0 _remove_duplicate_rooms/2:"+$("#roomlist ."+theclass+":last").data('perfid'));
                thisref._bindStreamPreviewLeave($("#roomlist ."+theclass+":last").data('perfid'),true);
                $("#roomlist_preload ."+theclass+":not(.duplicate)").last().remove();
            }
        });
    }

    /**************************************************************************/

    /**
     * Promocis banner hozzadasa
     */
    _renderHappyHourPromo(responseJSONParam = null) : Promise<void> {
        let _thisObj = this;

        return new Promise<void>((resolve, reject) => {
            try {
                if(responseJSONParam!=null){
                    onreadycall(responseJSONParam);
                    resolve();
                }else{
                    this.babesHandler._checkHappyHourPromo(false,true);

                    resolve();
                    /*$.ajax({
                        url      : '/ajax/api/getPromos',
                        type     : 'GET',
                        dataType : 'json',
                        data     : {}
                    }).done((responseJSON) => {
                        onreadycall(responseJSON);
                        resolve();
                    });*/
                }
            } catch(ex) { console.error(ex); reject(); }
        });

        function onreadycall(responseJSON){
            _thisObj.renderedHappyHour = responseJSON.result;

            //Happy Hour Promo
            if(responseJSON.result === true && $('#roomlist .happy-hour-promo').length==0) {
                // @ts-ignore
                let imgElement = $('<img>').attr('src', '/design/default/babes/images/promo/happyhour/echh_'+(responseJSON.extraCredit.bonus || 25)+'_'+__currLang+'.jpg?v=1498764525');
                let aElement = $('<a>').attr('href', 'javascript:void(0)');
                aElement.click((e) => {
                    // @ts-ignore
                    if(__isLoggedMember === true) {
                        _thisObj.babesHandler._checkHappyHourPromo(true);//fontos a sorrend utána a show()
                    }
                    else{ _thisObj.babesHandler.showPopup('loginpop'); }
                });
                aElement.append(imgElement);
                let liElement = $('<li>').addClass('promo').addClass('happy-hour-promo').append(aElement);
                $('#roomlist').prepend(liElement);
                _thisObj._addlastrooms_if_required(true);
            } else if(responseJSON.result === false) {
                try{clearTimeout(_thisObj.babesHandler.hhour_timeout);}catch(ex){}
                // @ts-ignore
                try{securionPayHandler.promo.clearPromo();}catch (e) {}
                if($ ('#roomlist .happy-hour-promo').length>0){
                    $('#roomlist .happy-hour-promo').remove();
                    _thisObj._addlastrooms_if_required(true);
                }
            }

            //TopRight Promo
            if(responseJSON.result_topright === true && $('#roomlist .top-right-promo').length==0) {
                // @ts-ignore
                let imgElement = $('<img>').attr('src', '/design/default/babes/images/topright-promo/topright_'+__currLang+'.jpg?v=1498764525');
                let aElement = $('<a>').attr('href', 'javascript:void(0)');
                aElement.click((e) => {
                    // @ts-ignore
                    if(__isLoggedMember === true) { window["chatClient"].app.view.topupPanel.show(); }
                    else{ _thisObj.babesHandler.showPopup('loginpop'); }
                });
                aElement.append(imgElement);
                let liElement = $('<li>').addClass('promo').addClass('top-right-promo').append(aElement);
                $('#roomlist').prepend(liElement);
                _thisObj._addlastrooms_if_required(true);
            } else if(responseJSON.result_topright === false) {
                try{clearTimeout(_thisObj.babesHandler.hhour_timeout);}catch(ex){}
                // @ts-ignore
                try{securionPayHandler.promo.clearPromo();}catch (e) {}
                if($ ('#roomlist .top-right-promo').length>0){
                    $('#roomlist .top-right-promo').remove();
                    _thisObj._addlastrooms_if_required(true);
                }
            }


        }
    }

    /**************************************************************************/

    /**
     * Rendereli a szoba listát
     */
    private last_renderroomlist_timestamp=6000;
    private lastrender_timout=-1;
    _renderRoomList(nicereload=false, forced=false) {
        let thisref=this;
        if(this.fullRoomList == null || this.fullRoomList.length==0) { return; }
        if(!$("section.onlineroom-section").is(":visible") || $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){return;}
        //onsole.log("Rendering roomlist?"+(new Date().getTime()-thisref.last_renderroomlist_timestamp));
        if(new Date().getTime()-thisref.last_renderroomlist_timestamp<200){
            try{clearTimeout(thisref.lastrender_timout);}catch (e) { }
            thisref.lastrender_timout=setTimeout(function () {    thisref._renderRoomList(nicereload,forced);  },350);
            return;
        }else{
            try{clearTimeout(thisref.lastrender_timout);}catch (e) { }
        }
        thisref.last_renderroomlist_timestamp=new Date().getTime();
        this.log("Rendering roomlist.");

        $("#main .content-loading").hide();

        let islastpage=(thisref.currentPage>=thisref._maxpage);
        if(!nicereload && !forced){thisref.currentPage = thisref.currentPage + 1;}

        let startIndex = $('#roomlist').find('li.room-item:not(.duplicate)').length /*- ((this.renderedHappyHour) ? 1 : 0)*/;
        if(nicereload || forced){startIndex=0;}
        let endIndex   = startIndex + this._configPerPage /*- ((this.renderedHappyHour && this.currentPage == 1) ? 2 : 0)*/;
        if(nicereload){endIndex=$('#roomlist').find('li.room-item:not(.hidden)').length;}
        if(forced){endIndex=startIndex + this._configPerPage*this.currentPage;}

        this.renderedRoomNum     = 0;

        $.each(this.fullRoomList.slice(startIndex, endIndex), (itemIndex, roomData) => {
            this._generateRoomItem(roomData,nicereload);
        });
        if(!nicereload){
            this._BigroomPlacer();
            this._StartStreamsRandom();
        }

        this.autoPagingScrollTop = $('footer').offset().top;

        $('#roomlist'+(nicereload?"_preload":"")).css('min-height', '');

        if(!nicereload && islastpage){
            thisref._addlastrooms_if_required(true);
        }
    }

    /**************************************************************************/

    /**
     * Lekérdezi a szobák listáját
     */
    _getRoomList() {
        let _thisObj = this;

        return new Promise<void>((resolve, reject) => {
            try {
                $.ajax({
                    url      : '/ajax/api/roomList/babes',
                    type     : 'GET',
                    dataType : 'json',
                    data     : {}
                }).done((responseJSON) => {
                    _thisObj.fullRoomList = responseJSON; resolve();

                    //feketelistások leghátulra
                    let tolast=_thisObj.fullRoomList.filter(function( obj ) { return obj.achievements.indexOf("blacklist") !== -1; });
                    _thisObj.fullRoomList = _thisObj.fullRoomList.filter(function( obj ) { return obj.achievements.indexOf("blacklist") === -1 ; });
                    _thisObj.fullRoomList = _thisObj.fullRoomList.concat(tolast);

                });
            } catch(ex) { reject(); }
        });
    }

    /**
     * Legenerálja a szobák listáját és beilleszti a DOM fába
     */
    _generateRoomItem(roomData,nicereload=false) {
        let modeElement = $('<div>').addClass('mode').html(this._textRoomMode(roomData.onlinestatus));
        let nameElement = $('<div>').addClass('name').html(roomData.screenname);
        let infoElement = $('<div>').addClass('info').append(modeElement).append(nameElement);

        if(this._getSmartToyByRoomData(roomData) !== false) {  // Ha van smarttoy eszköze, akkor az ikont hozzáadja
            let smartToyElement = $('<div>').addClass('smarttoy');

            infoElement.append(smartToyElement);
        }

        // @ts-ignore
        if(__isLoggedMember === true) {
            let favoriteElement = $('<a>').addClass('favorite').attr('title', this.babesHandler.getTranslate('mypagedisplay_addfavorite')).attr('href', 'javascript:void(0)').data('perfid', roomData.perfid);

            if(roomData.isFavorite === true) {
                favoriteElement.addClass('on').attr('title', this.babesHandler.getTranslate('mypagedisplay_delfavorite'));
            }

            infoElement.append(favoriteElement);
        }

        let linkElement     = $('<a>').attr('href', '/mypage/'+roomData.perfid+'/'+roomData.screenname+'/chat');
        //let linkElement     = $('<a>').attr('href', '/babes/chat?id='+roomData.perfid);
        let muteLinkElement = $('<a>').addClass('sound').click((e) => {
                                  if($(e.target).hasClass("on")) { $(e.target).removeClass('on'); } else { $(e.target).addClass('on'); }
                                  let videoElement = <HTMLVideoElement>document.getElementById('video_'+roomData.perfid); videoElement.muted = !videoElement.muted;
                              });
        infoElement.append(linkElement).append(muteLinkElement);

        let imgElement      = $('<img>').attr('src', roomData.roomimgid).attr('alt', roomData.screenname).attr('data-id', 0).attr('data-big-img', roomData.roomimgid_big).attr('onerror', "$('.room-item-"+roomData.perfid+"').addClass('hidden');roomListNG._addlastrooms_if_required(true);");
        let innerDivElement = $('<div>').addClass('room-inner').append(imgElement).append(infoElement);
        let roomDivElement  = $('<div>').addClass('room').append(innerDivElement);
        let mainElement     = $('<li>').addClass('room-item').addClass('room-item-'+roomData.perfid).addClass('page-'+this.currentPage).attr("data-achivements",roomData.achievements.join(" ")).attr("data-special",roomData.special_flag).append(roomDivElement);

        linkElement.click(() => {
            this._openPerformerFullscreen(roomData);
            /*var win = window.open('/mypage/'+roomData.perfid+'/'+roomData.screenname+'/chat', '_self');
            win.focus();*/
            return false;
        });

        if(roomData.special_flag && roomData.special_flag == 'pom') {
            let pomTextElement = $('<div>').addClass('pomtext').html(this.babesHandler.getTranslate('pom_text_normal').split('|').join('').replace('{{month}}', '').replace('{{screenname}}', ''));

            mainElement.addClass('pom').prepend(pomTextElement);
        }

        mainElement.addClass('room-mode-'+roomData.onlinestatus);
        mainElement.data('perfid', roomData.perfid);

        this._bindStreamPreview(mainElement);

        $('#roomlist'+(nicereload?"_preload":"")).append(mainElement);

        this.renderedRoomNum++;
    }


    /**
     * Chat bezárási múvelet megnyitott szoba esetén
     */
    public _closeChatFuncOpenedRoom(event=null,autojoin=true,fromeesckey=false){
        if(event!=null){
            event.preventDefault();
            event.stopImmediatePropagation(); //ez állítja meg a többi bind futást
        }
        if($(".sxcc-cam2cam").is(":visible")){
            window["chatClient"].app.view.cam2cam.leave();
            if(!fromeesckey){return;}
        }

        if(!$(".sxc-chat").hasClass("sxcc-size-fs")){
            roomListNG._closePerformerFullscreen(autojoin);
            $(".sxcc-obj-wrapper").removeClass("sxccs-float-over-reg");
        }else{
            window['chatClient'].app.view.setSize(window['chatClient'].app.view.prevSize);
        }
    }

    /**
     * Chat bezárási múvelet roomlistában
     */
    public _closeChatFuncRoomlist(event=null){
        if(event!=null){
            event.preventDefault();
            event.stopImmediatePropagation(); //ez állítja meg a többi bind futást
        }
        $(".chatroomcont").hide();
        $(".chatroomcont").attr("data-closed","true");
        window["chatClient"].app.close();
        $("#frame_chat-app").show();//topup miatt kell
        $(".sxcc-obj-wrapper").removeClass("sxccs-float-over-reg");
    }

    /**
     * Megnyitja a szobát nagyban
     */
    private lastscrolltop=0;
    private pophandler=null;
    private marker_for_hide_chat_if_needed=false;
    _openPerformerFullscreen(roomData) {
        let thisref=this;

        try{clearInterval(thisref.focuser);}catch (e) { }
        this.lastscrolltop=$(document).scrollTop();

        this.marker_for_hide_chat_if_needed=true;
        setTimeout(function () {thisref.marker_for_hide_chat_if_needed=false;},5000)

        //close button
        $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").off("click");
        $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").click(this._closeChatFuncOpenedRoom);
        $(window).off('popstate');
        this.pophandler=$(window).on('popstate', function(event) {
            if(window.location.href.indexOf("#")!==-1){
                window.history.pushState("", "", window.location.href.replace("#",""));
                return;
            }
            if(!$(".fancybox-container").is(":visible")){
                thisref._closePerformerFullscreen();
                if(window.location.href.indexOf("/mypage/")!==-1){window.history.replaceState("", "", '/live');}
            }
        });

        //státusz aktuális lekérdezés
        let perfid="";
        if(typeof roomData ==="undefined" || roomData== null){
            let arr1=window.location.href.split("/mypage/");
            let arr2=arr1[1].split("/");
            perfid=arr2[0];perfid=(arr2[0].split("?"))[0];
            //roomData={perfid:perfid};
        }
        else{perfid=roomData.perfid;}

        $.ajax({  url: '/ajax/api/roomList/babes-get-profile?perfid='+perfid, dataType: 'json'}).done((dataJson) => {

            //design módosítás
            $("section.onlineroom-section,body > footer ,.chatroomcont,#header").hide();
            $("#frame_chat-app,.chatroomcont").addClass("frame_chat-app-fullscreen").addClass("isloading");
            $("#frame_chat-app .frame-content").addClass("frame_chat-app-frame-content-fullscreen");
            $(".sxcc-close-chat").addClass("fullscreen-babes");
            $(".sxcc-tip-after-show-wrapper").hide();

            if(typeof dataJson["onlinestatus"]!== "undefined"){
                if(dataJson["onlinestatus"]=="offline"){
                    $(".sxcc-toast-wrapper").hide();
                    $(".sxcc-toast-wrapper").removeClass("sxc-visible");
                    setTimeout(function () { $(".sxcc-toast-wrapper").show();   },2000);

                    thisref.mypageHideTopChat();
                }
                else{thisref.mypageShowTopChat(); }
            }

            //join
            if(typeof roomData ==="undefined" || roomData== null){//konkrét szobára érkezés esetén
                window['chatClient'].app.allownextroom=false;
                window['chatClient'].app.options.chatIncludeType="babesIFrameFullscreen";
                window['chatClient'].app.showRoom(perfid/*, roomData.screenname, roomData.roomimgid, {}*/);
                //setTimeout(() => {  thisref.addUserDataFrame(perfid);}, 1);
                thisref.openroomdesignfix();
            } else {
                window['chatClient'].app.reset(() => {
                    if(roomData.onlinestatus == 'offline') { window['chatClient'].app.allownextroom=false; }

                    window['chatClient'].app.options.chatIncludeType="babesIFrameFullscreen";
                    //window['chatClient'].app.view.setSize("normal");

                    window['chatClient'].app.showRoom(roomData.perfid/*, roomData.screenname, roomData.roomimgid, {}*/);
                    //setTimeout(() => {  thisref.addUserDataFrame(roomData.perfid);}, 1);

                    thisref.openroomdesignfix();
                });
            }
        });

        //streamek leállítása a szobalistában
        $("#roomlist .room-item").each(function () {
            thisref.log("tryleave0 _openPerformerFullscreen:"+$(this).data('perfid'));
            thisref._bindStreamPreviewLeave($(this).data('perfid'),true);
            $(this).removeClass("asready");
            $(this).removeClass("autostart");
        });

        //scroll to top
        $('html, body').animate({ scrollTop:0}, 1);

        $(window).trigger("resize");
        this.centerTopRoomChat();

        //fix scrollbug after aarriving from email confirm
        $("#stripMessage").prependTo(".sxc-chat:first");
    }

    /**
     * openRoomdesignfix
     */
    openroomdesignfix(){
        let thisref=this;
        $("button[data-action='resize']").click(function(){
            setTimeout(function () { thisref.openroomdesignfix_set(); },100);
        });
        setTimeout(function () { thisref.openroomdesignfix_set(); },100);
    }
    openroomdesignfix_set(){
        if($(".sxc-chat").hasClass("sxcc-size-fb")){
            $("body").removeClass("gifts_body_oh");
        }else{
            $("body").addClass("gifts_body_oh");
        }
        $(window).resize();
    }


    /**
     * Bezárja a szobát
     */
    _closePerformerFullscreen(autojoin=true) {
        let thisref=this;

        //design módosítás
        $("section.onlineroom-section,body > footer,#header").show();
        $("#frame_chat-app,.chatroomcont").removeClass("frame_chat-app-fullscreen");
        $("#frame_chat-app .frame-content").removeClass("frame_chat-app-frame-content-fullscreen");
        $(".sxcc-close-chat").removeClass("fullscreen-babes");
        this.mypageShowTopChat();
        $("title").text(this.mainpagetitle);
        $("#video-player-teaser-cont").html("");
        $(".sxcc-wrapper").removeClass("teaseron");
        $("body").removeClass("gifts_body_oh");

       //előző pozícióra scroll
        $('html, body').animate({ scrollTop:this.lastscrolltop}, 1);

        if(window.location.href.indexOf("/mypage/")!==-1){window.history.replaceState("", "", '/live');}

        // hides Fan Club panel
        if (window.sxc && window.sxc.fanclub) {
            window.sxc.fanclub.panel.hide();
        }

        $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").off("click");
        $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").click(this._closeChatFuncRoomlist);

        //ha valamely oknál fogva nincsenek szobák (néha előjött)
        if($("#roomlist li:visible").length<10){$('.roomlist-paging').trigger('click');}

        //roomlista frissítése, ha kell promo miatt
        // @ts-ignore
        /*if($("#roomlist li.happy-hour-promo").length==0 && securionPayHandler.promo.promo!=null){
            //this._loadRoomList(false,true);
        }*/
        if(new Date().getTime() -this.lastrefreshed_ts>this.roomlist_auto_refresh_seconds*1000){
            this._loadRoomList(true,true);
        }else{
            //streamek elindítása a szobalistában
            this._StartStreamsRandom();
        }

        //join
        if(!this.topchatvisibleinroomlist){
            window['chatClient'].app.reset();
            $("#frame_chat-app").show();//topup miatt kell
        }else{
            window['chatClient'].app.reset(() => {
                if (autojoin) {
                    if ($(".chatroomcont").attr("data-closed") != "true") {
                        $(".chatroomcont").show();
                        window['chatClient'].app.allownextroom = true;
                        window['chatClient'].app.options.chatIncludeType = "babesIFrame";
                        window['chatClient'].app.view.setSize("normal");
                        thisref.joinRandomRoom();
                    } else {
                        window['chatClient'].app.close();
                        $("#frame_chat-app").show();//topup miatt kell
                    }
                }
            });
        }

        this.centerTopRoomChat();

        //Fix alert bug for mute
        $(".sxcc-toast-wrapper").removeClass("sxc-visible");
    }

    /**
     * Mypage top chat elrejtése
     */
    public mypageHideTopChat(reset=true) {
        $(".sxcc-wrapper").addClass("hiddenchat");
        if(reset){window['chatClient'].app.reset();}
    }

    /**
     * Mypage top chat megjelenítése
     */
    public mypageShowTopChat() {
        $(".sxcc-wrapper").removeClass("hiddenchat");
        $("#video-player-teaser-cont").html("");
        $(".frame-content > .frame-paging").appendTo(".frame-content .sxc-chat"); //Bal, Jobb szobaváltó pozícionálás
    }

    /**
     * Bigroomok elhelyezése a grid szabályoknak megfelelően
     */
    _BigroomPlacer(replaceFirstXBigroomToPremium=true,mainelement="#roomlist",childelement=".room-item",bigroomclass="bigroom",sordbMainElement="") {
        //hány oszlop van 1 sorban
        let sordb=this._getColcountPerRow((sordbMainElement==""?mainelement:sordbMainElement)+' '+childelement);
        if(sordb==1){return;}

        //alap paraméterek
        let spacebetweenbigrooms=this.spacebetweenbigrooms;
        let bigroomrowsize=this.bigroomrowsize;
        let bigroomcolsize=this.bigroomcolsize;
        let maxbigrooms=99999;
        if(mainelement=="#roomlist"){maxbigrooms=2;}
        let elements=$(mainelement+' '+childelement+':not(.brready,.hidden)').not("[data-achivements*='blacklist']");
        let thisref=this;
        let rowdiffsum=spacebetweenbigrooms+bigroomrowsize;
        let brcounter=$(mainelement+' '+childelement+'.brready').length+1;
        let startrow=this.bigroomstartrow;
        if($(mainelement+" .top-right-promo").length>0){startrow=startrow+2;}
        else if($(mainelement+" .happy-hour-promo").length>0){startrow++;}
        let lastbigrstartrow=brcounter>1?parseInt($(mainelement+' '+childelement+'.'+bigroomclass+':last').attr("data-row")):startrow-rowdiffsum;
        let bigcolstartvariations=[];for(var i=0;i<sordb-bigroomcolsize+1;i++){bigcolstartvariations.push(i+1);}
        let lastbigrstartcol= brcounter>1?parseInt($(mainelement+' '+childelement+'.'+bigroomclass+':last').attr("data-col")):bigcolstartvariations[Math.floor((Math.random()*bigcolstartvariations.length))];
        let pluszhelyfoglalas=(bigroomrowsize*bigroomcolsize)-1;
        this.log("Bigrooms add: "+mainelement+" "+childelement+" "+bigroomclass+" brcounter:"+brcounter+" elements:"+elements.length+" sordb:"+sordb+" ");

        //pozícionálás
        elements.each(function () {
            if($(mainelement+' '+childelement+'.'+bigroomclass).length<maxbigrooms){ _BigroomAdd($(this));}
        });

        if(replaceFirstXBigroomToPremium){this.replaceFirstXBigroomToPremium(2,mainelement,childelement,bigroomclass);}

        /**
         * Bigroom elhelyezése
         */
        function _BigroomAdd(element) {
            let curr_row=Math.ceil((brcounter+$(mainelement+' '+childelement+'.'+bigroomclass+'').length*pluszhelyfoglalas)/sordb);
            let curr_pos=(brcounter+$(mainelement+' '+childelement+'.'+bigroomclass+'').length*pluszhelyfoglalas)%sordb;
            if(curr_pos==0){curr_pos=sordb;}

            //thisref.log("Bigroom add: lastbigrstartrow:"+lastbigrstartrow+" rowdiffsum:"+rowdiffsum+" curr_row:"+curr_row+" sordb:"+sordb+" ");
            if( lastbigrstartrow+rowdiffsum==curr_row){
                element.addClass(bigroomclass);
                element.find("img:first").attr('src',element.find("img:first").attr("data-big-img"));
                //thisref._bindStreamPreviewEnter(element.data("perfid"), true);

                lastbigrstartrow=curr_row;
                element.css("grid-row-start",curr_row+"");

                let colvariants = bigcolstartvariations.filter(function(elem){//csak 1 oszlopnyi eltérés lehet
                    return ((elem != lastbigrstartcol && Math.abs(elem-lastbigrstartcol)==1) || sordb<=2);
                });

                let currcol=colvariants[Math.floor((Math.random()*colvariants.length))];
                lastbigrstartcol=currcol;
                element.css("grid-column-start",currcol+"");

                element.attr("data-col",currcol+"");
                element.attr("data-row",curr_row+"");
            }

            element.addClass("brready");
            brcounter++;
        }
    }

    /**
     * Bigroom cseréje
     */
    replaceFirstXBigroomToPremium(x,selectorroomlist="#roomlist",child=".room-item",bigrclass="bigroom") {
        for(let i=0;i<x;i++){
            let old=$(selectorroomlist+" "+child+"."+bigrclass).eq(i);
            if((typeof old.attr("data-achivements") == 'undefined' || old.attr("data-achivements").indexOf("premium") === -1)
                || (typeof old.attr("data-achivements") != 'undefined' && old.attr("data-achivements").indexOf("premium")!==-1 &&
                    (old.hasClass("room-mode-offline") || !old.hasClass("room-mode-free") )) ){
                let colorig=old.attr("data-col");
                let roworig=old.attr("data-row");
                let newpremiums=$(selectorroomlist+" "+child+".room-mode-free[data-achivements*='premium']:not(.bigroom)").not(".room-mode-offline").not("[data-achivements*='blacklist']");
                if(newpremiums.length==0){
                    newpremiums=$(selectorroomlist+" "+child+"[data-achivements*='premium']:not(.bigroom)").not(".room-mode-offline").not("[data-achivements*='blacklist']");
                }
                if(newpremiums.length==0){
                    newpremiums=$(selectorroomlist+" "+child+"[data-achivements*='premium']:not(.bigroom)").not("[data-achivements*='blacklist']");
                }
                if(newpremiums.length>0){
                    let newpremium=newpremiums.eq(this.GetRand(0,newpremiums.length-1));
                    //replace
                    newpremium.css("grid-column-start",colorig);
                    newpremium.attr("data-col",colorig);
                    newpremium.css("grid-row-start",roworig);
                    newpremium.attr("data-row",roworig);
                    newpremium.addClass(bigrclass);
                    newpremium.find("img:first").attr('src',newpremium.find("img:first").attr("data-big-img"));
                    old.removeAttr("style");
                    old.removeAttr("data-col");
                    old.removeAttr("data-row");
                    old.removeClass(bigrclass);
                }
            }
        }
    }

    /**
     * Streamek véletlen indítása (kb. 3 soronként 1)
     */
    _StartStreamsRandom() {
        if(window.location.href.indexOf("/mypage/")!==-1){return;}

        let sordb=this._getColcountPerRow('#roomlist .room-item');
        let elements=$('#roomlist .room-item:not(.asready,.hidden)');
        if(elements.length<25){return;}

        let brcounter=1;
        let laststartindex=1;
        let thisref=this;
        //let firshelper=thisref.GetRand(0, 2);
        elements.each(function () {
            if( $(this).hasClass("room-mode-free") /*&& ($(this).attr("data-achivements").indexOf("premium")!==-1 || $(this).attr("data-achivements").indexOf("MEMBER_FAVORITE")!==-1)*/
                    && (thisref.lastRandomFreeRoom==null || thisref.lastRandomFreeRoom.roomid!=$(this).data("perfid"))
                    && (typeof  window["chatClient"]==="undefined" || typeof  window["chatClient"].app==="undefined" || typeof  window["chatClient"].app.roomHistory==="undefined"  || window["chatClient"].app.roomHistory.length==0  ||
                        (window["chatClient"].app.roomHistory[window["chatClient"].app.roomHistory.length-1] != $(this).data("perfid"))  )
                    && (
                        (($(this).attr("data-achivements").indexOf("premium")!==-1 || $(this).attr("data-achivements").indexOf("MEMBER_FAVORITE")!==-1) && (laststartindex==1 || brcounter-laststartindex>thisref.GetRand(sordb*2,sordb*2.5)) )
                        || (laststartindex==1 /*&& firshelper==brcounter%3*/)
                        || brcounter-laststartindex>thisref.GetRand(sordb*2.5,sordb*3)
                        //|| ($(this).hasClass("bigroom") && thisref.GetRand(1,3) >1 )

                    )
                ){
                $(this).addClass("autostart");
                thisref._bindStreamPreviewEnter($(this).data("perfid"), true);
                laststartindex=brcounter;
            }
            $(this).addClass("asready");
            brcounter++;
        });
    }

    /**
     * Random integer
     */
    GetRand(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
    }

    /**
     * Visszaadja hány oszlop van egy sorban
     */
    _getColcountPerRow(selector) {
        let sordbcounter=1;let sordb=0;let lastpos=-1;
        $(selector).each(function(i){
            let current= $(this).position().top;
            if(current!=lastpos){sordbcounter=1;}
            else{sordbcounter++;}
            if(sordbcounter>sordb){sordb=sordbcounter;}
            lastpos=current;
        });
        return sordb;
    }

    /**
     * Ellenőrzi és visszaadja a smarttoy-t (ha van), szoba adatok alapján
     */
    _getSmartToyByRoomData(roomData) : string|boolean {
        if(typeof roomData.onlineparams == 'undefined' || roomData.onlineparams == null || typeof roomData.onlineparams.publicData == 'undefined' || typeof roomData.onlineparams.publicData.toys == 'undefined' || typeof roomData.onlineparams.publicData.toys.default == 'undefined') { return false; }

        return roomData.onlineparams.publicData.toys.default;
    }

    /**************************************************************************/

    /**
     * Elindítja a kép cserélés időzítőt
     */
    _startRoomPictureTimer() {
        setInterval(() => {
            if(this.focusedPage === false) { return; }

            let maxPerformerCount = this._configPerPage * this.currentPage;

            let randomPerformerIndex = Math.floor(Math.random() * maxPerformerCount);
            let randomPerformerData = this.fullRoomList[randomPerformerIndex];

            try{this._changeRoomPicture(randomPerformerData.perfid);}catch(ex){}
        }, 6000);
    }

    /**
     * Galéria megnyitása
     */
    public _changeRoomPicture(performerId) {
        if(this.nicereloading_in_progress){return;}

        let roomData = this._getRoomDataByPerfId(performerId);

        let performerPictureObj = $('.room-item-'+performerId).find('img');

        if(typeof roomData.newImages == 'undefined' || roomData.newImages.length == 0 || roomData.newImages.length <= parseInt(performerPictureObj.attr('data-id')) + 1) { return; }

        let randomPicture = roomData.newImages[parseInt(performerPictureObj.attr('data-id')) + 1];

        performerPictureObj.attr('data-id', parseInt(performerPictureObj.attr('data-id')) + 1);

        if(performerPictureObj.attr('src') == randomPicture.img_url) { return; }

        new Image().src = randomPicture.img_url;  // Preload Image
        setTimeout(() => {  // vár 2mp, hogy be tudja tölteni a képet
            performerPictureObj.animate({
                opacity: 0.5
            }, 800, () => {
                performerPictureObj.attr('src', randomPicture.img_url);
                performerPictureObj.animate({opacity: 1}, 800);
            });
        }, 3000);
    }

    /**************************************************************************/

    /**
     * Előlnézeti stream megnyitásának bindelése
     */
    public current_active_perf_id=-1;
    private last_hover_ts=0;
    private mouse_enter_timeout=0;
    _bindStreamPreview(domElement) {
        try {
            let _thisObj = this;

            domElement.on('mouseenter', function() {
                 _thisObj.current_active_perf_id=domElement.data('perfid');
                 try { clearTimeout(_thisObj.mouse_enter_timeout); } catch (ex2) {}
                _thisObj.mouse_enter_timeout=setTimeout(() => { _thisObj._bindStreamPreviewEnter(domElement.data('perfid'));}, 100);
            }).on('mouseleave', function() {
                _thisObj.current_active_perf_id=-1;
                try { clearTimeout(_thisObj.mouse_enter_timeout); } catch (ex2) {}
                _thisObj.log("tryleave mouseleave "+domElement.data('perfid'));
                _thisObj._bindStreamPreviewLeave(domElement.data('perfid'));
            });
        } catch (ex) {}
    }

    /**
     * Előlnézeti stream megnyitásának bindelése
     */
    _bindStreamPreviewEnter(performerId, autoStartPreview = false) {
        if($('#video_' + performerId).length != 0 && $('#video_' + performerId).hasClass('auto-preview')) { return; }
        //this._addLoadingIconToRoom(performerId);  // Töltő ikon hozzáadása a szobához

        if(autoStartPreview === false) {this._currentPreiviewPerformer = performerId; }
        this._bindStreamPreviewEnterCallback(performerId, autoStartPreview, this);
    }

    /**
     * Előlnézeti stream megnyitásának bindelése
     */
    _bindStreamPreviewEnterCallback(roomID, autoStartPreview, _thisObj) {
        try {
            let _this=this;
            this.log("tryenter:"+roomID);
            //this.log(responseJSON);
            //if(typeof responseJSON.data.onlineParams == 'undefined' || typeof responseJSON.data.onlineParams.modeSpecific == 'undefined' || typeof responseJSON.data.onlineParams.modeSpecific.main == 'undefined' || typeof responseJSON.data.roomID == 'undefined') { return; }

            var performerId = roomID;

            this.log("enter:"+performerId);

            if(autoStartPreview === false && _this._currentPreiviewPerformer != performerId) { return; }

            /*$('.room-item-'+performerId).find('.room-inner').append('<video id="video_'+performerId+'" style="z-index: 5; width: 100%;"></video>');
            if(autoStartPreview === true) { $('#video_' + performerId).addClass('auto-preview'); }
            var videoObject : HTMLVideoElement = <HTMLVideoElement>document.getElementById('video_'+performerId);*/


            if(_this._hlsSupport) {
                this.log("entering _hlsSupport:"+performerId);
                $('.room-item-'+performerId).find('.room-inner').append('<div id="video_'+performerId+'" style="z-index: 5; width: 100%;"><div class="stream"></div></div>');
                if(autoStartPreview === true) { $('#video_' + performerId).addClass('auto-preview'); }

                this.fillAndStream($("#video_"+performerId),roomID,"https://chat.a.apn2.com/chat-api/index.php/");
            } else{
                $('.room-item-'+performerId).find('.room-inner').append('<video id="video_'+performerId+'" style="z-index: 5; width: 100%;"></video>');
                if(autoStartPreview === true) { $('#video_' + performerId).addClass('auto-preview'); }
                var videoObject : HTMLVideoElement = <HTMLVideoElement>document.getElementById('video_'+performerId);

                if( videoObject.canPlayType('application/vnd.apple.mpegurl')){
                    $.ajax({
                        url      : 'https://chat.a.apn2.com/chat-api/index.php/chatPreview/getRoom',
                        type     : 'GET',
                        dataType : 'json',
                        data     : { "tokenID": "guest", "roomID": performerId }
                    }).done((responseJSON) => {
                        const streamUrl = responseJSON?.data?.onlineParams?.modeSpecific?.main?.hls?.address;

                        if (streamUrl) {
                            this.log("hls:"+performerId+" "+streamUrl);

                            this.log("nohls:"+performerId+" "+streamUrl);
                            videoObject.src = streamUrl;
                            videoObject.addEventListener('loadedmetadata',function() { videoObject.muted = true; videoObject.play(); /*_thisObj._removeLoadingIconToRoom(performerId);*/ });
                        }
                    });
                 }
            }
        } catch (ex) { $("#room-item-"+roomID).removeClass("autostart"); this.log(ex); /*_thisObj._removeLoadingIconToRoom(performerId);*/ }
    }

    /*Stream join segéd függvények */
    private rpwin=[];
    private fillAndStream = ($box, roomid, apiURL) =>
    {
        if(!(typeof this.rpwin[roomid] === "undefined" || this.rpwin[roomid]==null)){return;}
        console.log("ROOM", roomid);
        this.rpwin[roomid] = new window["SxcChatPreview"]($box.find(".stream")[0], {
            apiURL: apiURL
        });

        this.rpwin[roomid].setVolume(0);

        this.rpwin[roomid].showRoom(roomid, (mode) =>
        {
            console.log("ROOM", mode);
            if (mode !== "free" && mode !== "end") {
                if (this.rpwin[roomid]) {this.rpwin[roomid] = null;}
                $box.find(".stream").empty();
            }

            if((roomid+"").indexOf("v")===-1){
                $(".room-item-"+roomid).removeClass (function (index, className) {
                    return (className.match (/room-mode-([a-z])+/g) || []).join(' ');
                }).addClass("room-mode-"+mode);
                $(".room-item-"+roomid+" .info .mode").text(this._textRoomMode(mode));
            }
        });
    };
    private clearAndStop = ($box,performerId) => {
        if(typeof this.rpwin[performerId] === "undefined" || this.rpwin[performerId]==null){return;}
        this.rpwin[performerId].cancel(() => {
            this.log("ROOM END "+performerId);
            this.rpwin[performerId]=null;
            $box.find(".stream").empty();
            $box.find("img").hide();
        });
    };

    /**
     * Előlnézeti stream bezárás bindelése
     */
    private laststop_performerid=-1;
    private laststop_performer_timestamp=new Date().getTime();
    _bindStreamPreviewLeave(performerId, forceStopPreview = false) {
        this.log("tryleave:"+performerId);
        if((performerId==this.laststop_performerid && new Date().getTime()-this.laststop_performer_timestamp<500) || typeof performerId == 'undefined'){return;}
        this.log("leave:"+performerId);
        this.laststop_performerid=performerId;
        this.laststop_performer_timestamp=new Date().getTime();
        if($('#video_' + performerId).length != 0 && $('#video_' + performerId).hasClass('auto-preview') && forceStopPreview === false) { return; }
        //this.log("Destroy:"+performerId);

        try {
            this._currentPreiviewPerformer = null;

            //this._removeLoadingIconToRoom(performerId);  // Törli a töltő ikont a szobáról

            if(this._hlsSupport) {
                this.clearAndStop( $('#video_' + performerId),performerId);
                /*this._hlsObject[performerId] && this._hlsObject[performerId].destroy();
                this._hlsObject[performerId] = null;*/
            } else {
                var videoObject : HTMLVideoElement = <HTMLVideoElement>document.getElementById('video_'+performerId);
                videoObject.pause();
            }
        } catch (ex) {}

        $('#video_' + performerId).remove();
    }

    /**
     * Galéria megnyitása
     */
    _bindRoomGallery(performerId) {
        let elements = [];
        let roomData = this._getRoomDataByPerfId(performerId);

        if(typeof roomData.newImages == 'undefined') { return; }

        $.each(roomData.newImages, (itemIndex, itemData) => {
            elements.push({src: itemData.img_url, type: "image", opts: {caption: roomData.screenname, thumb: itemData.img_url }});
        });

        if(typeof roomData.teaserVideo != 'undefined' && roomData.teaserVideo !== false) {
            let videoData = this._getPerformerTeasterVideo(roomData);
            if(videoData.url) {
                elements.push({src: videoData.url, type: "video", opts: {caption: "" + videoData.title + "", thumb: videoData.poster}})
            }
        }

        if(elements.length > 0) {
            // @ts-ignore
            $.fancybox.open(elements, {
                loop: true,
                thumbs: {
                    autoStart: false
                }
            });
        }
    }

    /**************************************************************************/

    /**
     * Lapozó gomb felbindelése
     */
    _bindPagingLink() {
        let thisref=this;
        $('.roomlist-paging').click(() => {
            if(!$("section.onlineroom-section").is(":visible") || thisref.nicereloading_in_progress || $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){return;}
            if(thisref.currentPage<=thisref._maxpage){
                thisref._renderRoomList();
            }/*else{
                $(".roomlist-paging").show();
            }*/
        });
    }

    /**************************************************************************/

    /**
     * Töltő ikon hozááadása a szobához
     */
    _addLoadingIconToRoom(performerId) {
        //$('#room_'+performerId).find('.room').addClass('loading');
        if($('.room-item-'+performerId ).length>0 && $('.room-item-'+performerId ).hasClass("room-mode-free")){
            $('#wait').css("position","absolute");
            $('#wait').appendTo($('.room-item-'+performerId  )[0]);
            $("#wait").show(  );
            $('#wait').css("display","block");
        }
    }

    /**
     * Töltő ikon törlése a szobáról
     */
    _removeLoadingIconToRoom(performerId) {
        //$('#room_'+performerId).find('.room').removeClass('loading');
        $('.room-item-'+performerId+" #wait").hide();
    }

    /**************************************************************************/

    /**
     * Visszaadja a szoba állaponák megfelelő szöveget
     */
    _textRoomMode(roomMode : string) : string {
        try {
            // @ts-ignore
            if (typeof babes_roommodes == 'undefined') { return '-'; }

            // @ts-ignore
            if('roomcomp_type_'+roomMode in babes_roommodes) {
                // @ts-ignore
                return babes_roommodes['roomcomp_type_'+roomMode];
            } else {
                return '-';
            }
        } catch (e) { return '-'; }
    }

    /**************************************************************************/

    _getRoomDataByPerfId(performerId) {
        let responseRoomData;

        $.each(this.fullRoomList, (itemIndex, roomData) => {
            if(roomData.perfid == performerId) {
                responseRoomData = roomData;

                return false;
            }
        });

        return responseRoomData;
    }

    _getPerformerTeasterVideo(roomData) {
        return $.ajax({
            url      : 'https://videoman.a.apn2.com/api/videoPlayer/video/'+roomData.teaserVideo,
            type     : 'GET',
            dataType : 'json',
            data     : {},
            async: false
        }).responseJSON;
    }

    /*Média galéria ill. profil oldal kezelése*/
    private pagingProcess : boolean = true;
    private profileMedia : any = null;
    private profileMediaVideos : any = null;
    private profileMediaMaxPage : number = null;
    private profileMediaMaxPageVideos : number = null;
    private perPage : number = 20;
    private profilePage : number = 0;
    private profilePageVideos : number = 0;
    private profileLastId : string = '';
    private fanClubBannerRendered: boolean = false;
    addUserDataFrame(roomId : string) {
        let _this = this;

        let roomData = window["chatClient"].app.chatServer.roomList.getByID(roomId);
        /*if(typeof roomData.publicData !=="undefined" && typeof roomData.publicData.toys !=="undefined"){
            let hasToys = roomData.publicData.toys && !!roomData.publicData.toys.default;
        }else{ let hasToys =false;  }*/

        this.profileLastId = roomId;
        this.profilePage   = 0;
        this.profilePageVideos   = 0;
        this.profileMedia  = null;
        this.profileMediaVideos  = null;

        $('.sxcc-user-data').css("visibility","hidden");

        let streamBottom     = Math.round($('.sxcc-stream').outerHeight(true)) + Math.round($('.sxccb-actions').outerHeight(true)) + 8 + 157;

        let mainElement      = $('<div>').addClass('sxcc-user-data').data('perfid', roomId).css({top: streamBottom+'px'});
        let contentElement   = $('<div>').addClass('performercontent');
        let descElement      = $('<div>').addClass('performerdesc');
        let perfnavElement   = $('<div>').addClass('perfnav');
        let mediaElement     = $('<ul>').addClass('mediagallery');
        let videosElement    = $('<div>').addClass('videogallery').append('<ul id="videogalleryul" class="mediagallery"></ul>');
        let giftsElement     = $('<div>').addClass('gifts');
        let fanclubElement   = $('<ul>').addClass('fanclub').addClass('mediagallery');

        $('.sxcc-user-data').html("").css("min-width","100%").css("max-width","100%");

        let closeElement= $('<div class="close mypageclose"><a onclick="$(\'body\').trigger($.Event(\'keydown\', { keyCode: 27 }));" href="#"><i></i></a></div>');
        let videoPlayerTeaserElement= $('<div id="video-player-teaser-cont"></div>');

        perfnavElement.append(closeElement);

        mainElement.append(videoPlayerTeaserElement);
        mainElement.append(perfnavElement).append(descElement.hide()).append(videosElement.hide()).append(giftsElement.hide()).append(fanclubElement.hide());
        mainElement.append(contentElement.append(mediaElement));

        let videoElement   = $('<video>').attr('id', 'video-player').attr('width', '100%').attr('controls', 'true').attr("controlsList","nodownload").attr("oncontextmenu","return false;").css("max-height","100vh;");
        let pictureElement = $('<img>').attr('id', 'video-poster').attr('src', '').attr('width', '100%').css("max-height","calc(100vh - 50px)").css("width","auto");
        let messageElement = $('<div>').attr('id', 'video-message').hide();
        let videoContainerElement = $('<div>').attr('id', 'videoModal').attr('style', 'display: none; max-width: 1180px; max-height: 100%; padding: 0px;').append(pictureElement).append(videoElement).append(messageElement);

        let popupHTML = '<section class="popup" id="porfilepopup" style="display: none;"> <div class="window small"> <div class="close" onclick="$(\'#porfilepopup\').hide()"></div> <div class="header"></div> <div class="poparea maxheight"> <div class="popcontent"> <div class="scroll-wrapper inner scroll"></div> </div> </div>  </div> </section>';

        mainElement.append(videoContainerElement).append('<div class="chat_loding_cont"><span class="loading-animation-1"></span></div>').append(popupHTML);

        $('.sxcc-user-data').remove();
        $('.sxcc-wrapper').append(mainElement);

        let scrollTimer, lastScrollFireTime = 0;
        $('.sxc-chat, .frame-content').scroll(scroller);
        $(window).scroll(scroller);

        //Get Profile data
        $.ajax({
            url: '/page/profile?perfID='+roomId+'&tokenID='+window["chatClient"].app.options.auth.tokenID+"&dtype=babes",
            dataType: 'json'
        }).done((dataJson) => {
            _this.profileMedia = dataJson;
            _this.profileMediaVideos = JSON.parse(JSON.stringify(dataJson));//kell hogy ne referencia legtyen
            _this.profileMediaMaxPage = Math.ceil(_this.profileMedia.media.length / _this.perPage);

            mediaRenderer(_this.profileMedia,".performercontent",_this.profilePage);
            let sordb=_this._getColcountPerRow('.performercontent .mediagallery .mg-item');
            if(_this.profileMedia.media.length > 4 && _this.profileMedia.media.length>(sordb*(_this.bigroomrowsize+_this.bigroomstartrow-1)-(_this.bigroomrowsize*_this.bigroomcolsize))){
                _this.addBigroomsAndLAstroomsInPopup('.performercontent',_this.profilePage,_this.profileMediaMaxPage);
            }

            //Videók fül megjelenítése
            this.log("Check videos tab: _this.profileMedia.media.length:"+_this.profileMedia.media.length);
            let videoslength=0;let data1JsonArr=[];
            $.each(dataJson.media,function (itemKey, itemValue) {  if(itemValue.ext == 'video'){videoslength++;data1JsonArr.push(dataJson.media[itemKey])}  });
            _this.profileMediaVideos.media=data1JsonArr;
            _this.profileMediaMaxPageVideos = Math.ceil(this.profileMediaVideos.media.length / _this.perPage);
            _this.log("Check videos tab: _this.profileMediaVideos.media.length:"+_this.profileMediaVideos.media.length+" videoslength:"+videoslength);
            if(_this.profileMedia.media.length>=40 && videoslength>=8) {
                mediaRenderer(this.profileMediaVideos, ".videogallery", _this.profilePageVideos);
                if (this.profileMediaVideos.media.length > 4 && _this.profileMediaVideos.media.length > (sordb * (_this.bigroomrowsize + _this.bigroomstartrow - 1) - (_this.bigroomrowsize * _this.bigroomcolsize))) {
                    _this.addBigroomsAndLAstroomsInPopup('.videogallery', _this.profilePageVideos, _this.profileMediaMaxPageVideos, ".performercontent");
                }
            }else{ $("#profile_videos_li").hide(); }

            //gifts tab legyen aktív, ha szükséges
            if(_this.default_giftpage_show){
                _this.default_giftpage_show=false;
                $("#profile_gifts").click();
            }
        });

        $(document).on('afterShow.fb', (e, instance, slide) => {
            window["chatClient"].app.view.ignoreEsc(true);
        });
        $(document).on('beforeClose.fb', (e, instance, slide) => {
            setTimeout(() => {
                window["chatClient"].app.view.ignoreEsc(false);
                $(".fancybox-container").remove();//fancy box bug miatt, mert néha nem zárta be
            }, 500);
        });

        //Függvények

        function mediaRenderer(dataJson, parentElement,profilePage){
            _this.pagingProcess = true; let mediaElement = $(parentElement+' .mediagallery');

            //teaser video
            if(typeof dataJson.teaserVideo !== 'undefined' && dataJson.teaserVideo != null && typeof dataJson.teaserVideo.streamUrl !== 'undefined' && dataJson.teaserVideo.streamUrl != null) {
                mediaElement.attr("data-teaser",dataJson.teaserVideo.id);
            }

            $('.sxcc-user-data .loading-animation-1').hide();

            /*if(this.profilePage == 0) {
                let clearElement    = $('<div>').addClass('clear');
                let ratingElement   = $('<div>').addClass('rating');
                for(var i = 1; i <= dataJson.rating; i++) { let starOnElement   = $('<div>').addClass('star_on');  ratingElement.append(starOnElement); }
                for(var j = dataJson.rating + 1; j <= 5; j++) { let starOffElement  = $('<div>').addClass('star_off'); ratingElement.append(starOffElement); }
                ratingElement.append(clearElement);

                let descriptionElement = $('<button>').html('leírás');
                let divTagsElement  = $('<div>').addClass('tags').html(dataJson.tags);
                let h1NameElement   = $('<h1>').html(dataJson.name);
                let divEmptyElement = $('<div>').append(h1NameElement).append(ratingElement).append(divTagsElement).append(descriptionElement);
                let centerElement   = $('<div>').addClass('abscenter').append(divEmptyElement);
                let innerElement    = $('<div>').addClass('box-inner').addClass('profile').append(centerElement);
                let boxElement      = $('<div>').addClass('box').append(innerElement);
                let liElement       = $('<li>').append(boxElement);

                descriptionElement.on('click', () => {
                    $("#porfilepopup").find('.header').html(dataJson.name);
                    $("#porfilepopup").find('.popcontent').find('.inner').html(dataJson.desc);

                    $("#porfilepopup").show();
                });

                mediaElement.append(liElement);
            }*/

            addImagesVideosTabs();
            if (dataJson.fanclub) {
                renderFanClubMediaItems(dataJson.fanclub, _this.profileLastId);
            }
            addgiftsTab(_this.profileLastId);

            if(parentElement==".performercontent"){_this.profilePage=profilePage+1;}
            else{_this.profilePageVideos=profilePage+1;}
            _this.log("before profilePage++ "+profilePage);

            _this.pagingProcess = false;

            addTabsBar(_this.profileLastId);
            facybox_settings();

            //függvények
            function addTabsBar(roomId){
                if(perfnavElement.find("h1").length==0){
                    let ulTagsElement  = $('<ul>').addClass('perftags');
                    for(let tag in dataJson.tags){  ulTagsElement.append('<li>'+dataJson.tags[tag]+'</li>'); }
                    descElement.append(ulTagsElement);
                    descElement.append(''+dataJson.desc+"<br><br>");
                    perfnavElement.append('<h1>'+dataJson.name+'</h1><ul id="perfnavul"><li class="selected" id="profile_gallery_li"><a id="profile_gallery" href="javascript:void(0)">'+_this.babesHandler.getTranslate('profile_gallery')+'</a></li>' +
                        '<li id="profile_desc_li"><a id="profile_desc" href="javascript:void(0)">'+_this.babesHandler.getTranslate('profile_about')+'</a></li>' +
                        '<li id="profile_videos_li"><a id="profile_videos" href="javascript:void(0)">'+_this.babesHandler.getTranslate('header_menu_videos')+'</a></li>' +
                        '<li id="profile_gifts_li"><a id="profile_gifts" href="javascript:void(0)">'+_this.babesHandler.getTranslate('mypagedisplay_send_gift')+'</a></li></ul>');

                    const fanclub = dataJson.fanclub;
                    const navigation = $('#perfnavul');

                    if (fanclub) {
                        navigation.append('\
                            <li id="profile_fanclub_li">\
                                <a id="profile_fanclub" href="javascript:void(0)">\
                                    ' + _this.babesHandler.getTranslate('mypagedisplay_menu_fanclub') + '\
                                </a>\
                            </li>\
                        ');

                        if (fanclub.hasActiveSubscription) {
                            // `Send message` button
                            navigation.append('\
                                <li id="profile_fanclub_message_li" class="btn-action">\
                                    <a id="profile_fanclub_message" href="javascript:void(0)" class="btn">\
                                        ' + _this.babesHandler.getTranslate('mypagedisplay_menu_fanclub_message') + '\
                                    </a>\
                                </li>\
                            ');

                            $('body').on('click', '#profile_fanclub_message', () => {
                                window.sxc.fanclub.panel.showConversation(roomId);
                            });
                        } else {
                            // `Be my fan` button
                            navigation.append('\
                                <li id="profile_fanclub_start_li" class="btn-action">\
                                    <a id="profile_fanclub_start" href="javascript:void(0)" class="btn">\
                                        ' + _this.babesHandler.getTranslate('mypagedisplay_menu_fanclub_start') + '\
                                    </a>\
                                </li>\
                            ');

                            $('body').on('click', '#profile_fanclub_start', () => {
                                // @ts-ignore
                                if (window.chatClient.app.options.auth.tokenID === 'guest') {
                                    // @ts-ignore
                                    window.chatClient.app.showRegisterNeeded('free');
                                } else {
                                    window.sxc.fanclub.panel.showSubscribe(roomId);
                                }
                            });
                        }
                    }

                    // Tab klikkelések lekezelése
                    $("#profile_gallery").click(function () {
                        descElement.hide(); videosElement.hide();giftsElement.hide();fanclubElement.hide();contentElement.show();

                        $("#perfnavul > li").removeClass("selected");
                        $("#profile_gallery_li").addClass("selected");
                        handleFanClubButtonVisibility(fanclub);
                        $('html, body').animate({scrollTop: $(".perfnav").offset().top+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
                        $('.sxc-chat, .frame-content').animate({scrollTop: ($(".sxcc-wrapper").hasClass("hiddenchat")?0:$(".sxcc-wrapper").height()+25)+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
                    });
                    $("#profile_desc").click(() => desclick(fanclub));
                    $("#profile_videos").click(function () {
                        descElement.hide();contentElement.hide();giftsElement.hide();fanclubElement.hide();videosElement.show();

                        $("#perfnavul > li").removeClass("selected");
                        $("#profile_videos_li").addClass("selected");
                        handleFanClubButtonVisibility(fanclub);
                        $('html, body').animate({scrollTop: $(".perfnav").offset().top+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
                        $('.sxc-chat, .frame-content').animate({scrollTop: ($(".sxcc-wrapper").hasClass("hiddenchat")?0:$(".sxcc-wrapper").height()+25)+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
                    });
                    $("#profile_gifts").click(function () {
                        descElement.hide();contentElement.hide();videosElement.hide();fanclubElement.hide();giftsElement.show();

                        $("#perfnavul > li").removeClass("selected");
                        $("#profile_gifts_li").addClass("selected");
                        handleFanClubButtonVisibility(fanclub);
                        $('html, body').animate({scrollTop: $(".perfnav").offset().top+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
                        $('.sxc-chat, .frame-content').animate({scrollTop: ($(".sxcc-wrapper").hasClass("hiddenchat")?0:$(".sxcc-wrapper").height()+25)+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
                    });
                    $("#profile_fanclub").click(function () {
                        descElement.hide();contentElement.hide();videosElement.hide();giftsElement.hide();fanclubElement.show();

                        $("#perfnavul > li").removeClass("selected");
                        $("#profile_fanclub_li").addClass("selected");
                        handleFanClubButtonVisibility(fanclub);
                        $('html, body').animate({scrollTop: $(".perfnav").offset().top+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
                        $('.sxc-chat, .frame-content').animate({scrollTop: ($(".sxcc-wrapper").hasClass("hiddenchat")?0:$(".sxcc-wrapper").height()+25)+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
                    });

                    //ha guest
                    if (window["chatClient"].app.options.auth.tokenID === "guest") {
                        $(".mediagallery").addClass("blockedcontent");
                        $(".blockedcontent .mg-item").click(function (event) {
                            event.stopPropagation();
                            event.stopImmediatePropagation();
                            //_this.showToast(_this.babesHandler.getTranslate('guest_gallyery_notif'),true);
                            window['chatClient'].app.showRegisterNeeded("free");
                        });
                    }
                    if(dataJson.media.length==0){
                        $("#profile_gallery_li").hide();
                        desclick(fanclub);

                        //ha nincs gift vagy zizgő, a block eltüntetése
                        if($(".sxcc-special-gift-panel").css('visibility')=="hidden"){
                            $(".sxcc-user-data").css("margin-top","-147px").css("display","inline-block");
                        }
                    }
                }
            }

            function addImagesVideosTabs() {
                //Rendezés időpont szerint csökkenőbe
                for (var i = 0; i < dataJson.media.length; i++) { dataJson.media[i].created=new Date(dataJson.media[i].created);}
                dataJson.media=dataJson.media.sort((a, b) => b.created - a.created);

                let counter=0;
                _this.log("medirender data: "+dataJson.media.length+" "+profilePage+"/");
                $.each(dataJson.media.slice((profilePage) * (_this.perPage  ), ((profilePage+1) * _this.perPage) ), function(itemKey, itemValue) {
                    counter++;
                    if(itemValue.ext == 'image') {
                        let picElement   = $('<img>').attr('src', itemValue.url_thumb).attr('data-big-img', itemValue.url_bigbox);
                        let linkElement  = $('<a>').append(picElement).attr('href',"#");
                        if (window["chatClient"].app.options.auth.tokenID !== "guest") {
                            linkElement.attr('href', itemValue.url).addClass('fancybox').attr('data-fancybox', 'gallery').attr("data-protect","true");
                        }
                        linkElement.mousedown(function () {
                            _this.babesHandler.activitycheckeradd();
                        });
                        let innerElement = $('<div>').addClass('box-inner').addClass('profile').append(linkElement);
                        let boxElement   = $('<div>').addClass('box').append(innerElement);
                        let liElement    = $('<li data-id="'+'mg-item-'+(new Date().getTime())+counter+'">').addClass('mg-item').append(boxElement);

                        mediaElement.append(liElement);
                    } else if(itemValue.ext == 'video') {
                        let liElement=addVideoLiElement(itemValue);
                        liElement.attr("data-id",'mg-item-'+(new Date().getTime())+counter);
                        mediaElement.append(liElement);
                    }

                    // shows Fan Club banner after third media item
                    if (_this.fanClubBannerRendered === false && counter === 3) {
                        renderFanClubBanner(dataJson.fanclub, _this.profileLastId, mediaElement);
                        _this.fanClubBannerRendered = true;
                        counter++;
                    }
                });
                _this.log("medirender data: "+dataJson.media.length+" "+profilePage+"/");
            }

            /**
             * Renders Fan Club banner.
             *
             * @param {Object} fanclub
             * @param {Number} roomId
             * @param {Object} container
             */
            function renderFanClubBanner(fanclub, roomId, container) {
                // @ts-ignore
                const loggedIn = window.chatClient.app.options.auth.tokenID !== 'guest';
                // @ts-ignore
                const language = __currLang;
                const babesHandler = _this.babesHandler;

                if (!fanclub || (loggedIn === true && fanclub.hasActiveSubscription === true)) {
                    return false;
                }

                const banner = $('<li>').addClass('doubleheight fanclub-banner').html('\
                    <div class="fanclub-banner-box">\
                        <div class="fanclub-banner-box-inner">\
                            <div class="content">\
                                <h2 class="title">' + babesHandler.getTranslate('fanclub_banner_be_my_fan') + '</h2>\
                                <div class="counter-container">\
                                    <div class="counter">+' + fanclub.extraMediaCount + '</div>\
                                    <div class="counter-text counter-text-' + language + '"><span>' + babesHandler.getTranslate('fanclub_banner_premium') + '</span> ' + _this.babesHandler.getTranslate('fanclub_banner_picture_and_video') + '</div>\
                                </div>\
                                <ul>\
                                    <li>' + babesHandler.getTranslate('fanclub_banner_feature_private_message') + '</li>\
                                    <li>' + babesHandler.getTranslate('fanclub_banner_feature_own_appointment') + '</li>\
                                    <li>' + babesHandler.getTranslate('fanclub_banner_feature_fresh_premium_content') + '</li>\
                                </ul>\
                                <div class="btn-container">\
                                    <button class="btn" type="button">' + babesHandler.getTranslate('fanclub_banner_btn_membership') + '</button>\
                                </div>\
                            </div>\
                            <a href="#" class="link-overlay"></a>\
                        </div>\
                    </div>\
                ');

                banner.find('.link-overlay').click(e => {
                    e.preventDefault();

                    if (loggedIn === true) {
                        window.sxc.fanclub.panel.showSubscribe(roomId);
                    } else {
                        // @ts-ignore
                        window.chatClient.app.showRegisterNeeded('free');
                    }
                });

                container.append(banner);
            }

            /**
             * Render Fan Club media items.
             *
             * @param {Object} fanclub
             * @param {Number} roomId
             */
            function renderFanClubMediaItems(fanclub, roomId) {
                // @ts-ignore
                const loggedIn = window.chatClient.app.options.auth.tokenID !== 'guest';

                // locks media items
                if (loggedIn === true && fanclub.hasActiveSubscription === false) {
                    $('.fanclub.mediagallery').addClass('blockedcontent');
                }

                fanclub.mediaList.map((item, index) => {
                    const img = $('<img>')
                        .addClass('lazyload')
                        .attr('data-src', item.thumbnail)
                        .attr('data-big-img', item.thumbnail);

                    const link = $('<a>')
                        .append(img)
                        .attr('href','#');

                    if (fanclub.hasActiveSubscription === true && item.source) {
                        link.attr('href', item.source)
                            .addClass('fancybox')
                            .attr('data-thumb', item.thumbnail)
                            .attr('data-fancybox', 'gallery1')
                            .attr("data-protect",'true');
                    }

                    const badge = $('<span>')
                        .addClass('badge-exclusive')
                        .html(_this.babesHandler.getTranslate('badge_exclusive'));

                    // todo: implement condition for exclusive badge (currently tagging all media items)
                    link.append(badge);

                    const boxInner = $('<div>').addClass('box-inner profile').append(link);
                    if (item.type === 'video') {
                        boxInner.append($('<div>').addClass('video'));
                    }

                    const box = $('<div>').addClass('box').append(boxInner);

                    const ms = new Date().getTime();
                    const listItem = $('<li>')
                        .attr('data-id', 'mg-item-' + ms + (index + 1))
                        .addClass('mg-item')
                        .mousedown(() => {
                            if (loggedIn === true) {
                                if (fanclub.hasActiveSubscription === true) {
                                    // @ts-ignore
                                    babesHandler.activitycheckeradd();
                                } else {
                                    window.sxc.fanclub.panel.showSubscribe(roomId);
                                }
                            } else {
                                // @ts-ignore
                                window.chatClient.app.showRegisterNeeded('free');
                            }
                        })
                        .append(box);

                    fanclubElement.append(listItem);
                });

                /** @ts-ignore */
                lazyload();
            }

            function addgiftsTab(roomId2){
                if($("#myPage .send-gift").length>0){return;}

                //gift lista
                let giftshtml='<div id="myPage"><div class="send-gift"><div class="normal-gifts">';

                $.each(dataJson.gifts.full, function(itemKey, itemValue) {
                    giftshtml+='<div class="category"><h1>'+itemValue.name+'</h1><div class="list clearfix">';
                    $.each(itemValue.items, function(itemKey2, itemValue2) {
                        giftshtml+='<div class="gift" data-id="'+itemValue2.id+'" data-price="'+itemValue2.price+'" data-roomid="'+roomId2+'"><div class="inner">' +
                            '<img src="'+dataJson.gifts.imageServerAssetURL+'/gift/'+itemValue2.id+'.png?v=1" class="image" alt="'+itemValue2.name+'" />' +
                            '<div class="details"><div class="name">'+itemValue2.name+'</div><div class="price">'+itemValue2.priceText+'</div></div>' +
                            '<div class="details2"><input type="button" class="button choose" value="'+_this.babesHandler.getTranslate('mypage_gift_page_purchase')+'"/></div>';
                        giftshtml+='</div></div>';
                    });
                    giftshtml+='</div></div>';
                });
                giftshtml+='</div></div></div>';
                giftsElement.append(giftshtml);

                //dialog
                let gifts_dialog_html='<div class="gifts_dialog_container popup hidden"><div class="gifts_dialog_inner">' +
                        '<div class="gifts_dialog_before"><div class="gifts_dialog_close" onclick="$(\'.gifts_dialog_container\').addClass(\'hidden\')"><i class="sxcc-icon gifts-close"></i></div><img src="" class="giftimg"></img>' +
                            '<div class="gifts_dialog_title1"></div>' +
                            '<div class="gifts_dialog_title2"></div> ' +
                             '<div class="gifts_dialog_textarea"><textarea placeholder="'+_this.babesHandler.getTranslate('mypage_gift_page_dialog_leave_message').replace('|','')+'"></textarea></div> ' +
                            '<div class="gifts_dialog_title3"></div>' +
                            '<div class="gifts_dialog_button sxc-form"><button class="sxcf-button sxcf-button-primary">'+_this.babesHandler.getTranslate('mypagedisplay_send_gift')+'</button></div>' +
                         '</div>' +
                        '<div class="gifts_dialog_after"><div class="gifts_dialog_close" onclick="$(\'.gifts_dialog_container\').addClass(\'hidden\')"><i class="sxcc-icon gifts-close"></i></div><img src="" class="giftimg"></img>' +
                            '<div class="gifts_dialog_title1"></div>' +
                            '<div class="gifts_dialog_title2">'+_this.babesHandler.getTranslate('mypage_gift_suprise_after_sent')+'</div> ' +
                            '<div class="gifts_dialog_button sxc-form"><button class="sxcf-button sxcf-button-primary"></button></div>' +
                        '</div>' +
                        '<div class="gifts_dialog_after_error"><div class="gifts_dialog_close" onclick="$(\'.gifts_dialog_container\').addClass(\'hidden\')"><i class="sxcc-icon gifts-close"></i></div><img src="" class="giftimg"></img>' +
                           '<div class="gifts_dialog_title1">'+_this.babesHandler.getTranslate('mypage_gift_page_dialog_error')+'</div>' +
                            '<div class="gifts_dialog_title2"></div> ' +
                            '<div class="gifts_dialog_button sxc-form"><button class="sxcf-button sxcf-button-primary"></button></div>' +
                        '</div>' +
                    '</div></div>';

                let gift_interval1=-1;
                if($(".gifts_dialog_container").length==0){
                    $(".sxc-chat").append(gifts_dialog_html);
                    $(".gifts_dialog_before .gifts_dialog_button button").click(function () {
                        let giftID=$(this).closest(".gifts_dialog_container").attr("data-giftid");
                        let price=$(this).closest(".gifts_dialog_container").attr("data-price");
                        let roomId3=$(this).closest(".gifts_dialog_container").attr("data-roomid");
                        let text= $(".gifts_dialog_before .gifts_dialog_textarea textarea").val();

                        // @ts-ignore
                        if(!__isLoggedMember){ongiftsenderror("");}
                        else{
                            $.ajax({  url: '/ajax/api/roomList/babes-get-profile?perfid='+roomId3, dataType: 'json'}).done((dataJson) => {
                                if (typeof dataJson["onlinestatus"] !== "undefined") {
                                    if (dataJson["onlinestatus"] == "offline") {
                                        $.post(
                                            "/ajax/credit/sendgift",
                                            {giftID: giftID, perfID: roomId3, message: text},
                                            function(r) { //ha success
                                                if(r.success){   ongiftsendsuccess();
                                                }else { ongiftsenderror(r.reason);}
                                            }
                                        ).error(function(e) {  console.error(e);   alert(_this.babesHandler.getTranslate('myaccount_email_technical')); })
                                    } else {
                                        // @ts-ignore
                                        chatClient.app.chatServer.sendGift(roomId3, giftID, text, price,
                                            function(r){  ongiftsendsuccess(); }, function(r){  ongiftsenderror(r.failureReason);  }
                                        );
                                    }
                                }
                            });
                        }
                    });
                    $(".gifts_dialog_after .gifts_dialog_button button").click(function () {
                        $('.gifts_dialog_container').addClass('hidden');
                    });
                }

                //listában kattintás gift-re
                giftsElement.find(".gift").click(function () {
                    clearInterval(gift_interval1);
                    $(".gifts_dialog_container,.gifts_dialog_before").removeClass("hidden");
                    $(".gifts_dialog_after,.gifts_dialog_after_error").addClass("hidden");
                    $(".gifts_dialog_before .gifts_dialog_title1,.gifts_dialog_after .gifts_dialog_title1").html(_this.babesHandler.getTranslate('mypage_gift_suprise_after').replace("{{name}}",dataJson.name));
                    $(".gifts_dialog_before .gifts_dialog_title2").html($(this).find(".name").text()+" / "+$(this).find(".price").text());
                    $(".gifts_dialog_before .gifts_dialog_title3").html($("#header #logged_in_username").text());
                    $(".gifts_dialog_before .gifts_dialog_textarea textarea").html("");
                    $(".gifts_dialog_before .gifts_dialog_textarea textarea").val("");
                    $(".gifts_dialog_after .gifts_dialog_button button").html(_this.babesHandler.getTranslate('mypage_gift_page_dialog_close')+' (6)');
                    $(".gifts_dialog_container").attr("data-giftid",$(this).attr("data-id"));
                    $(".gifts_dialog_container").attr("data-price",$(this).attr("data-price"));
                    $(".gifts_dialog_container").attr("data-roomid",$(this).attr("data-roomid"));
                    $(".gifts_dialog_container .giftimg").attr("src",$(this).find(".image").attr("src"));
                });

                function ongiftsendsuccess(){
                    $(".gifts_dialog_before").addClass("hidden");
                    $(".gifts_dialog_after").removeClass("hidden");
                    let gifts_counter=6;
                    gift_interval1=setInterval(function(){
                        if(gifts_counter==0){
                            clearInterval(gift_interval1);
                            $(".gifts_dialog_after .gifts_dialog_button button").click();
                        }
                        $(".gifts_dialog_after .gifts_dialog_button button").text($(".gifts_dialog_after .gifts_dialog_button button").text().replace("("+gifts_counter+")","("+(gifts_counter-1)+")"));
                        gifts_counter--;
                    }, 1000);
                    _this.babesHandler._checkTopupBalance();
                }

                function ongiftsenderror(reason){
                    $(".gifts_dialog_before").addClass("hidden");
                    $(".gifts_dialog_after_error").removeClass("hidden");
                    $(".gifts_dialog_after_error .gifts_dialog_title2").text(_this.babesHandler.getTranslate('gift_widget_error_gift_' + reason));
                    if (reason == "ooc") {
                        $(".gifts_dialog_after_error .gifts_dialog_title2").text(_this.babesHandler.getTranslate('mypage_gift_suprise_creditadd' + reason));
                        $(".gifts_dialog_after_error .gifts_dialog_button button").text(_this.babesHandler.getTranslate('mypage_gift_suprise_creditadd'));
                        $(".gifts_dialog_after_error .gifts_dialog_button button").off("click");
                        $(".gifts_dialog_after_error .gifts_dialog_button button").click(function () {
                            _this.babesHandler._checkTopupBalance();
                            _this.babesHandler._checkHappyHourPromo(true);
                            $(".gifts_dialog_before").removeClass("hidden");
                            $(".gifts_dialog_after_error").addClass("hidden");
                        });
                    }
                    // @ts-ignore
                    else if(!__isLoggedMember){
                        $(".gifts_dialog_after_error .gifts_dialog_title2").text(_this.babesHandler.getTranslate('mypage_gift_suprise_must_register'));
                        $(".gifts_dialog_after_error .gifts_dialog_button button").text(_this.babesHandler.getTranslate('join_button'));
                        $(".gifts_dialog_after_error .gifts_dialog_button button").off("click");
                        $(".gifts_dialog_after_error .gifts_dialog_button button").click(function () { _this.babesHandler.showPopup('regpop')});
                    }else{
                        $(".gifts_dialog_after_error .gifts_dialog_title2").text(_this.babesHandler.getTranslate('gift_widget_error_gift_'+reason));
                        $(".gifts_dialog_after_error .gifts_dialog_button button").text(_this.babesHandler.getTranslate('mypage_gift_page_dialog_close'));
                        $(".gifts_dialog_after_error .gifts_dialog_button button").off("click");
                        $(".gifts_dialog_after_error .gifts_dialog_button button").click(function () {
                            $('.gifts_dialog_container').addClass('hidden');
                        });
                    }
                }
            }

            function facybox_settings(){
                $('[data-fancybox]').fancybox({
                        // loop : true,
                        animationEffect: "fade",
                        thumbs : {
                            autoStart   : false
                        },
                        slideShow: {
                            autoStart: false,
                            speed: 3000
                        },
                    },
                );
            }

            function addVideoLiElement(itemValue) {
                let picElement   = $('<img>').attr('src', itemValue.poster_thumb).attr('data-big-img', itemValue.poster_bigbox);
                let linkElement  = $('<a>').attr('href', 'javascript:;').append(picElement);
                let stateElement = $('<div>').addClass('video');
                let innerElement = $('<div>').addClass('box-inner').append(linkElement).append(stateElement);
                let boxElement   = $('<div>').addClass('box').append(innerElement);
                let overlayElement = $('<div>').addClass('event-overlay');
                if (window["chatClient"].app.options.auth.tokenID !== "guest") {
                    overlayElement.addClass('fancybox').attr('data-fancybox', '').attr('data-src', '#videoModal') .attr('data-modal', 'false');
                }
                let liElement    = $('<li>').addClass('mg-item').addClass('profile-video-item').append(boxElement).append(overlayElement);

                if (window["chatClient"].app.options.auth.tokenID !== "guest") {
                    overlayElement.on('click', () => {
                        $('#video-player, #video-poster').hide();
                        $('#video-poster').parent().find('a').remove();
                        $('#video-message').hide();
                        if( $('#video-message').parent().find('#video-title').length==0){
                            $('#video-message').after('<div id="video-title"></div>');
                        }

                        let videoObj = <HTMLVideoElement>document.getElementById('video-player');
                        videoObj.muted = window["cookie"].read("vid_muted")=="0"?false:true;
                        videoObj.controls = true;

                        videoObj.pause();
                        videoObj.removeAttribute("src");
                        videoObj.load();

                        $(videoObj).on('play pause ended timeupdate volumechange', function () {
                            let thiref=$(this);
                            setTimeout(function () {
                                window["cookie"].erase("vid_muted");
                                if(!(<HTMLVideoElement>thiref[0]).muted){
                                    window["cookie"].create("vid_muted","0");
                                }
                            },300);
                        });

                        $.ajax({
                            url: 'https://videoman.a.apn2.com/api/videoPlayer/video/' + itemValue.id + '?tokenID=' + window["chatClient"].app.options.auth.tokenID,
                            dataType: 'json'
                        }).done((videoData) => {
                            $('#video-title').html(videoData.title);
                            if (videoData.status == 402) {
                                $('#video-poster').attr('src', itemValue.poster).show();
                                _this.log(videoData);
                                let buyButton = $('<a>').attr('href', 'javascript:void(0)').addClass('buy-button');
                                buyButton.html('<div class="round">'+_this.babesHandler.getTranslate("profile_gallery_show_video_before")+'<div class="length">'+(new Date(videoData.length * 1000).toISOString().substr(11, 8)).replace(/^00\:/g, '')+'</div></div>' +
                                    '<div class="round-hover"><span>'+_this.babesHandler.getTranslate("profile_gallery_show_video")+'</span><div class="credits">'+videoData.price+' '+_this.babesHandler.getTranslate("profile_gallery_show_video_credits")+'</div></div>');
                                buyButton.on('click', () => {
                                    $.post('https://videoman.a.apn2.com/api/videoPlayer/purchase/' + itemValue.id + '?tokenID=' + window["chatClient"].app.options.auth.tokenID, {}, (data) => {
                                        if (data.success === true) {
                                            $('#video-player').show();
                                            $('#video-poster').hide();
                                            $('#video-poster').parent().find('a').remove();

                                            videoObj.src = data.url;
                                            videoObj.load();
                                            videoObj.play();

                                            $("#video-title").fadeOut("fast").delay(3000).fadeIn();
                                            $("#video-message").html( _this.babesHandler.getTranslate('profile_gallery_show_video_successful_buy')).removeClass("middle");
                                            $("#video-message").fadeIn("fast").delay(3000).fadeOut();

                                            $(".sxcc-wrapper:not(.hiddenchat) .sxcc-volume-control button:not(:has(.sxcc-icon-vol0))").click();//mute chat
                                        } else {
                                            if (data.reason == 'ooc') {
                                                $('#video-message').html(window["chatClient"].app.translator.t("ooc_default")).show();
                                                $('#video-message').addClass("middle");
                                                $('#video-message').click(function () {
                                                    $("button[data-fancybox-close]").click();
                                                    // @ts-ignore
                                                    window["chatClient"].app.view.topupPanel.show();
                                                });
                                                $('#video-message').delay(10000).fadeOut();
                                            }
                                        }
                                    });
                                });
                                $('#video-poster').parent().append(buyButton);
                            } else {
                                $('#video-player').show();

                                videoObj.src = videoData.url;
                                videoObj.load();
                                videoObj.play();

                                $(".sxcc-wrapper:not(.hiddenchat) .sxcc-volume-control button:not(:has(.sxcc-icon-vol0))").click();//mute chat
                            }
                        });
                        this.babesHandler.activitycheckeradd();
                    });
                }
                return liElement;
            }
        }

        /**
         * Handles visibility of Fan Club action button.
         *
         * @param {Object} fanclub
         */
        function handleFanClubButtonVisibility(fanclub) {
            // @ts-ignore
            const loggedIn = window.chatClient.app.options.auth.tokenID !== 'guest';
            const btn = $('.btn-action');

            // shows button on all tabs if there is an active subscription
            if (loggedIn === true && fanclub.hasActiveSubscription === true) {
                btn.show();
                return false;
            }

            // shows button only on certain tabs if there is no active subscription
            const selectedTab = $("#perfnavul > li.selected").attr('id');
            const allowedTabs = ['profile_fanclub_li'];

            if (allowedTabs.indexOf(selectedTab) !== -1) {
                btn.show();
            } else {
                btn.hide();
            }
        }

        function desclick(fanclub) {
            contentElement.hide();videosElement.hide();giftsElement.hide(); descElement.show();
            $("#perfnavul > li").removeClass("selected");
            $("#profile_desc_li").addClass("selected");
            handleFanClubButtonVisibility(fanclub);
            $('html, body').animate({ scrollTop:$(".perfnav").offset().top+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
            $('.sxc-chat, .frame-content').animate({scrollTop: ($(".sxcc-wrapper").hasClass("hiddenchat")?0:$(".sxcc-wrapper").height()+25)+($("#video-player-teaser-cont").is(":visible")?$("#video-player-teaser-cont").height():0)}, 300);
        }

        function scroller() {
            if (_this.pagingProcess !== false || _this.profileMedia === null
                || (_this.profilePage >= _this.profileMediaMaxPage && $("#profile_gallery_li").hasClass("selected"))
                || (_this.profilePageVideos >= _this.profileMediaMaxPageVideos && $("#profile_videos_li").hasClass("selected"))
                || $("#profile_desc_li").hasClass("selected")  || $("#profile_gifts_li").hasClass("selected")) { return; }

            var minScrollTime = 100;
            var now = new Date().getTime();

            let processScroll = (parentelement,profilePage,profileMediaMaxPage,profileMedia) => {
                _this.log("scrolll processScroll");
                let scrollerTop  = $(parentelement+' .mediagallery').find('li').last().offset().top;
                let windowHeight = $(window).scrollTop();
                if($(".sxc-chat").hasClass("sxcc-size-fb")){
                    windowHeight=$(window).scrollTop()+$(window).height();
                    scrollerTop=$("#frame_chat-app").height()+$(".sxcc-user-data").height();
                }
                else if($(".sxc-chat").hasClass("sxcc-size-normal")){
                    windowHeight=$(window).height();
                }

                if(scrollerTop - windowHeight < 50) {
                    _this.log("scrolll mediaRenderer "+profilePage+"/"+profileMediaMaxPage+" profileMedia length:"+profileMedia.media.length+" parentelement:"+parentelement);
                    mediaRenderer(profileMedia,parentelement,profilePage);
                    _this.addBigroomsAndLAstroomsInPopup(parentelement,parentelement==".performercontent"?_this.profilePage:_this.profilePageVideos,profileMediaMaxPage);
                }
            }

            if (typeof scrollTimer=="undefined" || scrollTimer==null) {
                if (now - lastScrollFireTime > (3 * minScrollTime)) {
                    try{clearTimeout(scrollTimer);}catch (e) { }
                    _this.log("scrolll triggered "+(now - lastScrollFireTime )+" "+(3 * minScrollTime));
                    lastScrollFireTime = now;
                    // fire immediately on first scroll
                    if($("#profile_gallery_li").hasClass("selected")){ processScroll(".performercontent",_this.profilePage,_this.profileMediaMaxPage,_this.profileMedia);  }
                    else if($("#profile_videos_li").hasClass("selected")){ processScroll(".videogallery",_this.profilePageVideos,_this.profileMediaMaxPageVideos,_this.profileMediaVideos);  }
                }else{
                    try{clearTimeout(scrollTimer);}catch (e) { }
                    scrollTimer = setTimeout(function() {
                        _this.log("scrolll triggered timeout");
                        scrollTimer = null;
                        lastScrollFireTime = new Date().getTime();
                        if($("#profile_gallery_li").hasClass("selected")){ processScroll(".performercontent",_this.profilePage,_this.profileMediaMaxPage,_this.profileMedia);  }
                        else if($("#profile_videos_li").hasClass("selected")){ processScroll(".videogallery",_this.profilePageVideos,_this.profileMediaMaxPageVideos,_this.profileMediaVideos);  }
                    }, minScrollTime);
                }
            }
        }
    }

    addBigroomsAndLAstroomsInPopup(parentelement,profilePage,profileMediaMaxPage,sordbparentelement="") {
        this._BigroomPlacer(false,parentelement+" .mediagallery",".mg-item","bigbox",sordbparentelement==""?parentelement:sordbparentelement);
        this.log("Lastroom add before (popup) "+profilePage+" "+profileMediaMaxPage);
        if(profilePage >= profileMediaMaxPage){
            this.log("Lastroom add (popup) "+profilePage+" "+profileMediaMaxPage);
            this._addlastrooms_if_required(true,parentelement+" .mediagallery",".mg-item","bigbox","",sordbparentelement==""?parentelement:sordbparentelement);
        }
    }

    /* Segédfüggvény véletlen rendezés*/
    shuffle(arra1) {
        var ctr = arra1.length, temp, index;

        // While there are elements in the array
        while (ctr > 0) {
        // Pick a random index
            index = Math.floor(Math.random() * ctr);
        // Decrease ctr by 1
            ctr--;
        // And swap the last element with it
            temp = arra1[ctr];
            arra1[ctr] = arra1[index];
            arra1[index] = temp;
        }
        return arra1;
    }

    /*Chat alapú toast üzenet*/
    private toast_timout=-1;
    showToast(message="",floattype=false){
        window["chatClient"].app.view.toastManager.push( message,{timeout: 5000, instant: true, strong: true, floattype: floattype} );
    }

    /*Logging függvény*/
    log(msg=""){
        if(this.consoleLogging){console.log(msg);}
    }
}


var roomListNG = new RoomList();
